(function($){
var $ = jQuery = $;

window.slate = window.slate || {};
window.theme = window.theme || {};

/*============== Translations ===============*/
theme.strings = $.extend(theme.strings, {
  addressError: "Translation missing: en.map.errors.address_error",
  addressNoResults: "Translation missing: en.map.errors.address_no_results",
  addressQueryLimit: "Translation missing: en.map.errors.address_query_limit_html",
  authError: "Translation missing: en.map.errors.auth_error_html",
  addingToCart: "Adding",
  addedToCart: "Added",
  goToCart: "Go to cart",
  cart: "Cart",
  cartTermsNotChecked: "you must agree to the terms and conditions before continuing.",
  searchLoading: "Translation missing: en.layout.header.search_loading",
  searchNoResults: "Translation missing: en.layout.header.search_no_results",
  quantityTooHigh: "you can only have {{ quantity }} in your cart",
  searchResultsPages: "Pages",
  searchResultsViewAll: "view all [TOTAL] results",
  searchResultsNoResults: "Sorry, we couldn\u0026#39;t find any results"
});

/*================ Icons ================*/
theme.icons = {
  check: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>',
  chevronRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>',
  arrowLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>'
};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    
    this._updateSwatch(this.currentVariant); //CD
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
      this._updateSwatch(variant); //CD

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    
    //CD swatch
    _updateSwatch: function(variant) {
      if (variant) {
        var variant_title = variant.title.toLowerCase();
        var form = jQuery('.formATC-' + this.product.id);
        
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
          if (radioButton.length) {
            radioButton.get(0).checked = true;
          }
        }
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*=============== Components ===============*/
// Loading third party scripts, with callbacks
theme.scriptsLoaded = {};
theme.loadScriptOnce = function(src, callback, beforeRun) {
  if(typeof theme.scriptsLoaded[src] === 'undefined') {
    theme.scriptsLoaded[src] = [];
    var tag = document.createElement('script');
    tag.src = src;

    if(beforeRun) {
      tag.async = false;
      beforeRun();
    }

    if(typeof callback === 'function') {
      theme.scriptsLoaded[src].push(callback);
      if (tag.readyState) { // IE, incl. IE9
        tag.onreadystatechange = (function() {
          if (tag.readyState == "loaded" || tag.readyState == "complete") {
            tag.onreadystatechange = null;
            for(var i = 0; i < theme.scriptsLoaded[this].length; i++) {
              theme.scriptsLoaded[this][i]();
            }
            theme.scriptsLoaded[this] = true;
          }
        }).bind(src);
      } else {
        tag.onload = (function() { // Other browsers
          for(var i = 0; i < theme.scriptsLoaded[this].length; i++) {
            theme.scriptsLoaded[this][i]();
          }
          theme.scriptsLoaded[this] = true;
        }).bind(src);
      }
    }

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return true;
  } else if(typeof theme.scriptsLoaded[src] === 'object' && typeof callback === 'function') {
    theme.scriptsLoaded[src].push(callback);
  } else {
    if(typeof callback === 'function') {
      callback();
    }
    return false;
  }
}

theme.addNoticeToForm = function($notice, $form) {
  var $existingNotices = $('.ajax-add-notice', $form);
  if($existingNotices.length > 0) {
    setTimeout(function(){ // wait until fading-out has definitely finished
      $existingNotices.replaceWith($notice.addClass('ajax-add-notice--pre-replace'));
      setTimeout(function(){
        $notice.removeClass('ajax-add-notice--pre-replace');
      }, 10);
    }, 251);
  } else {
    $notice.addClass('ajax-add-notice--pre-reveal').appendTo($form).slideDown(250, function(){
      $(this).removeClass('ajax-add-notice--pre-reveal');
    });
  }
};

$(document).on('submit', 'form[action^="/cart/add"][data-ajax-add="true"]', function(e) {
  var $form = $(this);
  // Disable add button
  $form.find(':submit').attr('disabled', 'disabled').each(function(){
    var contentFunc = $(this).is('button') ? 'html' : 'val';
    $(this).data('previous-value', $(this)[contentFunc]())[contentFunc](theme.strings.addingToCart);
  });

  // Hide any notices
  $('.ajax-add-notice', $form).css('opacity', 0);

  // Add to cart
  $.post('/cart/add.js', $form.serialize(), function(itemData) {

    // Enable add button
    var $btn = $form.find(':submit').each(function(){
      var $btn = $(this);
      var contentFunc = $(this).is('button') ? 'html' : 'val';
      // Revert to normal
      $btn.removeAttr('disabled')[contentFunc]($btn.data('previous-value'));
    }).first();


    // reload header
    $.get('/search', function(data){
      var selectors = [
        '.page-header .cart'
      ];
      var $parsed = $($.parseHTML('<div>' + data + '</div>'));
      for(var i=0; i<selectors.length; i++) {
        var cartSummarySelector = selectors[i];
        var $newCartObj = $parsed.find(cartSummarySelector).clone();
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);
      }
      theme.checkCurrency();
    });

    // display added notice
    /*var $template = $([
      '<div class="ajax-add-notice ajax-add-notice--added global-border-radius">',
        '<div class="ajax-add-notice__inner">',
          '<div class="ajax-add-notice__item">',
            '<span class="feather-icon">', theme.icons.check, '</span>',
            theme.strings.addedToCart,
          '</div>',
          '<div class="ajax-add-notice__go">',
            '<a href="/cart">',
              theme.strings.goToCart,
              '<span class="feather-icon feather-icon--small">', theme.icons.chevronRight, '</span>',
            '</a>',
          '</div>',
        '</div>',
      '</div>'
    ].join(''));

    theme.addNoticeToForm($template, $form);*/ /* CD */
    
    document.dispatchEvent(new CustomEvent("sideCartRefresh")); //CD

  }, 'json').fail(function(data) {
    // Enable add button
    var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function(){
      var $btn = $(this);
      var contentFunc = $btn.is('button') ? 'html' : 'val';
      $btn[contentFunc]($btn.data('previous-value'))
    }).first();

    // Not added, show message
    /*if(typeof(data) != 'undefined' && data.responseJSON && data.responseJSON.description) {
      var $template = $([
        '<div class="ajax-add-notice ajax-add-notice--error global-border-radius">',
          '<div class="ajax-add-notice__inner">',
            data.responseJSON.description,
          '</div>',
        '</div>'
      ].join(''));
      theme.addNoticeToForm($template, $form);
    } else {
      // Some unknown error? Disable ajax and submit the old-fashioned way.
      $form.attr('data-ajax-add', false);
      $form.submit();
    }*/ /* CD */
  });
  return false;
});


/*================ Sections ================*/
/**
 * Sidebar section Script
 * ------------------------------------------------------------------------------
 *
   * @namespace sidebar
 */

theme.Sidebar = (function() {
  /**
   * Sidebar page constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Sidebar(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);

    // check sidebar exists
    this.sidebarExists = !!$('.sidebar', container).length;
    $('.template-index').toggleClass('page-has-sidebar', this.sidebarExists);
  }


  Sidebar.prototype = $.extend({}, Sidebar.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
    }
  });

  return Sidebar;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productFeaturedImageWithGallery: '[data-product-featured-image]:not(.product-image--no-gallery)',
    productThumbnailForCarouselContainer: '.product-thumbnails--inline',
    productThumbnailImage: '.product-thumbnails__link',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    desktopProductThumbs: '.product-thumbnails--desktop [data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    styledSelect: '.selector-wrapper select',
    skuWrapper: '.product-sku',
    sku: '.product-sku__value'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$desktopProductThumbs = $(selectors.desktopProductThumbs, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if(this.$container.find(selectors.skuWrapper)) {
      this.$container.on('variantChange' + this.namespace, this.updateSKU.bind(this));
    }

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    this.$thumbnails = $(selectors.productThumbnailImage, container);
    if (this.$thumbnails.length > 0) {
      this.$container.on('click' + this.namespace, selectors.productThumbnailImage, this.selectThumbnailImage.bind(this));
    }

    // image zoom
    this.$container.on('click' + this.namespace, selectors.productFeaturedImageWithGallery, this.openGallery.bind(this));

    // style dropdowns
    theme.styleVariantSelectors($(selectors.styledSelect, container), options.product);

    if(this.$thumbnails.length > 0) {
      // mobile carousel
      this.$thumbnailForCarouselContainer = $(selectors.productThumbnailForCarouselContainer, container);
      this.assessMobileCarousel.bind(this)();
      $(window).on('debouncedresize' + this.namespace, this.assessMobileCarousel.bind(this));

      // reveal thumbnails now - avoiding lazysizes + slick conflict
      this.$thumbnails.find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Switches thumbnails into a carousel on mobile
     */
    assessMobileCarousel: function() {
      // test by checking if single image is visible
      if(!this.$featuredImage.is(':visible')) {
        if(!this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {
          this.$thumbnailForCarouselContainer.addClass('slick-slider');
          this.$thumbnailForCarouselContainer.slick({
            autoplay: false,
            fade: false,
            infinite: true,
            useTransform: true,
            dots: true,
            adaptiveHeight: true,
            initialSlide: $('.product-thumbnails__item--active', this.$thumbnailForCarouselContainer).index() || 0
          });
        }
      } else {
        if(this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {
          this.$thumbnailForCarouselContainer.slick('unslick');
          this.$thumbnailForCarouselContainer.removeClass('slick-slider');
        }
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      var btnTxt = $(selectors.addToCart, this.$container).attr('data-label'); //CD

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('product-price--unavailable');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('product-price--unavailable');
        return;
      }
      
      var qty = 1;
      var title = variant.title.toLowerCase();
      if(title.indexOf('twin') >= 0) qty = 2;
      $('.proQty', this.$container).attr('data-times',qty);
      var qty_val = $('.proQty', this.$container).length?$('.proQty', this.$container).val():1;
      $('.product_detail .times-pack').text(parseInt(qty_val*qty));

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(btnTxt); //CD*
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }

      // backorder
      var $backorderContainer = $('.backorder', this.$container);
      if($backorderContainer.length) {
        if(variant && variant.available) {
          var $option = $(selectors.originalSelectorId + ' option[value="' + variant.id + '"]', this.$container);
          if(variant.inventory_management && $option.data('stock') == 'out') {
            $backorderContainer.find('.backorder__variant').html(this.productSingleObject.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - ' + variant.title) );
            $backorderContainer.show();
          } else {
            $backorderContainer.hide();
          }
        } else {
          $backorderContainer.hide();
        }
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var $price = $(selectors.productPrice, this.$container);

      //Cd after pay code
      var ap_price=slate.Currency.formatMoney((variant.price/4), theme.moneyFormat) 
      $('.afterpay-info b').html(ap_price);
      $price.html('<span class="theme-money">' + slate.Currency.formatMoney(variant.price, theme.moneyFormat) + '</span>');

      var $form = this.$container.find(".formProduct");
      var $original_price = $form.find(".original_price");

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html('<span class="theme-money">' + slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</span>');
        $compareEls.removeClass('hide');
        $price.addClass('product-price__reduced');

        var compare_price_elem = document.createElement("DIV");
        var qty = parseInt($form.find("input[name='quantity']").val());
        compare_price_elem.innerHTML = slate.Currency.formatMoney(variant.compare_at_price * qty, theme.moneyFormat);

        if($original_price.length) {
          $original_price.attr("data",variant.compare_at_price);
          $original_price.val(compare_price_elem.textContent);
        } else  {
          $form.append('<input type="hidden" name="properties[Original price]" class="original_price" data="'+variant.compare_at_price+'" value="'+compare_price_elem.textContent+'" />')
        }
        
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
        $price.removeClass('product-price__reduced');

        if($original_price.length) $original_price.remove();
      }
      
      theme.checkCurrency();
    },

    /**
     * Updates the SKU
     */
    updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant && variant.sku) {
        $(selectors.skuWrapper, this.$container).removeClass('product-sku--empty');
        $(selectors.sku, this.$container).html(variant.sku);
      } else {
        $(selectors.skuWrapper, this.$container).addClass('product-sku--empty');
        $(selectors.sku, this.$container).empty();
      }
    },

    /**
     * Display selected thumbnail
     */
    selectThumbnailImage: function(evt) {
      var $thumbnailContainer = $(evt.currentTarget).parent();
      if(!$thumbnailContainer.hasClass('product-thumbnails__item--active')) {
        var $newImage = $(evt.currentTarget).clone();
        $newImage.removeClass('product-thumbnails__link')
          .addClass('product-image__link')
          .find('.rimage-wrapper')
          .addClass('lazyload--placeholder')
          .find('.rimage__image')
          .removeAttr('srcset')
          .removeClass('lazyloaded')
          .addClass('lazyload');
        this.$featuredImage.html($newImage);
        $thumbnailContainer
          .addClass('product-thumbnails__item--active')
          .siblings('.product-thumbnails__item--active')
          .removeClass('product-thumbnails__item--active');

          // if in carousel
        if($thumbnailContainer.hasClass('slick-slide')) {
          $thumbnailContainer.closest('.slick-slider').slick('slickGoTo', $thumbnailContainer.data('slick-index'));
        }
      }
      evt.preventDefault();
    },

    /**
     * Updates the DOM with the specified image URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      if(variant.featured_image) {
        $('.product-thumbnails__link[data-thumbnail-image-id="' + variant.featured_image.id + '"]').trigger('click');
      }
    },

    /**
     * Show gallery of all product images
     */
    openGallery: function(evt) {
      evt.preventDefault();

      var pswpElement = document.querySelectorAll('.pswp')[0];

      var items = [];
      if(this.$desktopProductThumbs.length) {
        this.$desktopProductThumbs.each(function(){
          var item = {
            src: $(this).attr('href'),
            w: $(this).data('image-w'),
            h: $(this).data('image-h')
          };
          var img = $(this).find('img')[0];
          if(typeof img.currentSrc !== 'undefined') {
            item.msrc = img.currentSrc;
          }
          items.push(item);
        });
      } else {
        var item = {
          src: this.$featuredImage.find('a').attr('href'),
          w: this.$featuredImage.data('image-w'),
          h: this.$featuredImage.data('image-h')
        };
        var img = this.$featuredImage.find('img')[0];
        if(typeof img.currentSrc !== 'undefined') {
          item.msrc = img.currentSrc;
        }
        items.push(item);
      }

      var options = {
        index: $(evt.target).closest('a').data('image-index'),
        history: false,
        captionEl: false,
        shareEl: false,
        fullscreenEl: false,
        getThumbBoundsFn: (function(index) {
          var thumbnail = this.$desktopProductThumbs.is(':visible') ? this.$desktopProductThumbs[index].getElementsByTagName('img')[0] : this.$featuredImage.find('img')[0],
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }).bind(this)
      };

      // Initializes and opens PhotoSwipe
      this.imageGallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      this.imageGallery.init();
      this.imageGallery.listen('destroy', (function(){
        this.imageGallery = null;
      }).bind(this));
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      $(window).off(this.namespace);
      if(this.imageGallery) {
        this.imageGallery.close();
      }
      if(this.$thumbnailForCarouselContainer) {
        this.$thumbnailForCarouselContainer.filter('.slick-slider').slick('unslick');
      }
    }
  });

  return Product;
})();

/**
 * Header Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Header
 */

theme.Header = (function() {
  /**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.mobileMenuTransitionTime = 500;

    this.$searchBar = $('.search-bar', container);
    this.$newsletterSignupButton = $('.js-header-newsletter-open', this.$container);

    /**
     * Making search bar un-tabbable on page load
     */
    $('.header-search-form', this.$container).find('a, button, input').attr('tabindex', '-1');

    /**
     * Toggle header search bar open
     */
    $('.js-header-search-trigger', this.$container).on('click' + this.namespace, (function(e){
      e.preventDefault();
      $('body').toggleClass('show-search');
      $('.header-search-form', this.$container).find('a, button, input').removeAttr('tabindex');
      $('.header-search-form .search-form__input', this.$container).focus();
    }).bind(this));

    /**
     * Fetch search results for entered text
     */
    $('.search-form__input', this.$container).on('change' + this.namespace + ' keyup' + this.namespace + ' paste' + this.namespace, (function(e){
      this.fetchSearchResults.bind(this)(e);
    }).bind(this));

    // mobile menu events
    $(this.$container).on('click' + this.namespace, '.js-mobile-menu-icon', this.mobileMenuOpen.bind(this));
    $(this.$container).on('click' + this.namespace, '.js-close-mobile-menu', this.mobileMenuClose.bind(this));
    this.$mobileDropdownContainer = $('.mobile-nav-column-inner', container);

    // cd code (Mobile Menu Dropdown)
    // $(this.$container).on('click' + this.namespace, '.js-mobile-dropdown-trigger', this.mobileMenuDropdownOpen.bind(this));
    // $(this.$container).on('click' + this.namespace, '.js-mobile-dropdown-return', this.mobileMenuDropdownClose.bind(this));


    // open newsletter form on click
    if(this.$newsletterSignupButton.length > 0) {
      $(this.$container).on('click' + this.namespace, '.js-header-newsletter-open', function(){
        $.colorbox({
          transition: 'none',
          html: $('.header-newsletter-wrapper').html(),
          onOpen: theme.colorboxFadeTransOnOpen,
          onComplete: theme.colorboxFadeTransOnComplete
        });
      });
      // show newsletter form if it contains messages
      if($('.header-newsletter-wrapper .form-success, .header-newsletter-wrapper .errors').length) {
        $.colorbox({
          transition: 'fade',
          html: $('.header-newsletter-wrapper').html(),
          onOpen: theme.colorboxFadeTransOnOpen,
          onComplete: theme.colorboxFadeTransOnComplete
        });
      }
    }

    // aria labels
    $('.main-nav__has-dropdown > a, .main-nav__child-has-dropdown > a', this.$container).attr('aria-haspopup', 'true').attr('aria-expanded', 'false');
    this.$container.on('mouseenter' + this.namespace + ' mouseleave' + this.namespace, '.main-nav__has-dropdown, .main-nav__child-has-dropdown', function(evt){
      if(evt.type == 'mouseenter') {
        $(this).children('[aria-expanded]').attr('aria-expanded', true);
        $(this).addClass('show-dropdown');
      } else {
        $(this).children('[aria-expanded]').attr('aria-expanded', false);
        $(this).removeClass('show-dropdown');
      }
    });

    // keyboard navigation - press enter to open
    this.$container.on('keydown' + this.namespace, '.main-nav__has-dropdown > .main-nav__link, .main-nav__child-has-dropdown > .main-nav__child-link', (function(evt){
      if(evt.which == 13) {
        if($(evt.target).parent().hasClass('show-dropdown')) {
          $(evt.target).trigger('mouseleave');
        } else {
          $(evt.target).trigger('mouseenter');
        }
        evt.preventDefault();
      }
    }).bind(this));

    // touch events
    $(this.$container).on('touchstart' + this.namespace + ' touchend' + this.namespace + ' click' + this.namespace, '.main-nav__has-dropdown > .main-nav__link, .main-nav__child-has-dropdown > .main-nav__child-link', function(evt){
      if(evt.type == 'touchstart') {
        $(this).data('touchstartedAt', evt.timeStamp);
      } else if(evt.type == 'touchend') {
        // down & up in under a second - presume tap
        if(evt.timeStamp - $(this).data('touchstartedAt') < 1000) {
          $(this).data('touchOpenTriggeredAt', evt.timeStamp);
          if($(this).parent().hasClass('show-dropdown')) {
            // trigger close
            $(this).trigger('mouseleave');
          } else {
            // trigger close on any open items
            $('.main-nav .show-dropdown').removeClass('show-dropdown').children('a').attr('aria-expanded', false);
            // trigger open
            $(this).trigger('mouseenter');
          }
          // prevent fake click
          return false;
        }
      } else if(evt.type == 'click') {
        // if touch open was triggered very recently, prevent click event
        if($(this).data('touchOpenTriggeredAt') && evt.timeStamp - $(this).data('touchOpenTriggeredAt') < 1000) {
          return false;
        }
      }
    });

    // keep menus in viewport
    this.assessMenuPositions.bind(this)();
    $(window).on('debouncedresize' + this.namespace, this.assessMenuPositions.bind(this));
  };


  Header.prototype = $.extend({}, Header.prototype, {
    /**
    * Ensure dropdown menus do not go off the right-edge of the page
    */
    assessMenuPositions: function(){
      var windowWidth = $(window).width();
      $('.main-nav__dropdown', this.$container).each(function(){
        var thisWidth = $(this).outerWidth();

        // this dropdown
        var gutter = 20;
        var marginLeft = parseInt($(this).css('margin-left')) || 0;
        var offEdgeAmount = windowWidth - gutter - (($(this).offset().left - marginLeft) + thisWidth);
        $(this).css('margin-left', offEdgeAmount < 0 ? offEdgeAmount : '');

        // child dropdown
        $(this).toggleClass(
          'main-nav__dropdown--expand-left',
          $(this).offset().left + thisWidth * 2 > windowWidth
        );
      });
    },

    /**
    * Fetching search results
    */
    fetchSearchResults: function(e){
      var $input = $(e.target);
      var terms = $input.val();

      // only do something if search terms have changed
      if(terms != $input.data('previous-terms')) {
        $input.data('previous-terms', terms);

        // is it a valid search term
        if(terms.length > 0) {
          // abort first, let callbacks run
          if(this.searchXhr) {
            this.searchXhr.abort();
          }

          // add class to show results, in case it's closed. Also hide existing items.
          this.$searchBar.addClass('search-bar--show-results search-bar--loading').removeClass('search-bar--has-results');

          // build search url
          var $form = $input.closest('form');
          var searchUrl = $form.attr('action');
          $(':input[name]', $form).each(function(index){
            // url divider
            searchUrl += searchUrl.indexOf('?') < 0 ? '?' : '&';
            // param
            searchUrl += $(this).attr('name') + '=';
            if($(this).is('[name="q"]')) {
              searchUrl += encodeURI($(this).val()) + '*';
            } else {
              searchUrl += encodeURI($(this).val());
            }
          });

          // fetch search results
          this.searchXhr = $.getJSON(
            searchUrl + '&view=json',
            this.buildSearchResults.bind(this, searchUrl)
          ).always(function(){
            this.searchXhr = null;
            this.$searchBar.removeClass('search-bar--loading');
          }.bind(this));
        } else {
          if(this.searchXhr) {
            this.searchXhr.abort();
          }
          this.$searchBar.removeClass('search-bar--loading');
          if(this.$searchBar.find('.search-bar__suggestions').length === 0) {
            this.$searchBar.removeClass('search-bar--show-results');
          }
        }
      }
    },

    /**
    * Build search results from response
    */
    buildSearchResults: function(searchUrl, data){
      this.$searchBar.addClass('search-bar--has-results');
      var $resultsContainer = $('.search-bar__results-list', this.$searchBar).empty();
      if(data.results_total > 0) {
        var $productResults = $('<div class="search-bar__results-products">');
        var $pageResults = $('<div class="search-bar__results-pages">');
        for(var i = 0; i < data.results.length; i++) {
          var p = data.results[i];
          if(p.type == 'product') {
            var $item = $('<a class="mini-product">').attr('href', p.url);
            var $imgCont = $('<div class="mini-product__image-container">').appendTo($item);
            if(p.thumb) {
              $('<img class="mini-product__image"/>').attr('src', p.thumb).appendTo($imgCont);
            }
            var $details = $('<div class="mini-product__details">').appendTo($item);
            $('<div class="mini-product__title">').html(p.title).appendTo($details);
            var $price = $('<div class="mini-product__price">').html(slate.Currency.formatMoney(p.price, theme.moneyFormat)).appendTo($details);
            if(p.comparePrice > p.price) {
              $price.addClass('mini-product__price--on-sale');
            }
            $item.appendTo($productResults);
          } else {
            $('<a class="search-bar__results-pages__link">').attr('href', p.url).html(p.title).appendTo($pageResults);
          }
        }
        $resultsContainer.append($productResults);
        if($pageResults.children().length) {
          $('<h6 class="search-bar__results-pages-title small-cap-heading">').html(theme.strings.searchResultsPages).prependTo($pageResults);
          $resultsContainer.append($pageResults);
        }
        $('<a class="search-bar__results-all-link">').html(theme.strings.searchResultsViewAll.replace('[TOTAL]', data.results_total)).attr('href', searchUrl).appendTo($resultsContainer);

        theme.checkCurrency();
      } else {
        $('<div>').html(theme.strings.searchResultsNoResults).appendTo($resultsContainer);
      }
    },

    /**
     * Event for showing the mobile navigation
     */
    mobileMenuOpen: function(evt) {
      evt.preventDefault();
      $(document.body).addClass('mobile-menu-prime');
      setTimeout(function(){
        $(document.body).addClass('mobile-menu-open');
      }, 10);
    },

    /**
     * Event for closing the mobile navigation
     */
    mobileMenuClose: function(evt) {
      evt.preventDefault();
      $(document.body).removeClass('mobile-menu-open');
      
      setTimeout(function(){
        $(document.body).removeClass('mobile-menu-prime');
      }, 500);
    },

    /**
     * Event for opening a mobile dropdown menu
     */
    mobileMenuDropdownOpen: function(evt) {
      evt.preventDefault();
      var $dropdownToShow = $(evt.currentTarget).siblings('.main-nav__dropdown');
      if($dropdownToShow.length) {
        // show level 2 dropdown
        var $newDropdown = $dropdownToShow.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-2">').parent();
        // add return link
        $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">').html(
          [
            '<span class="feather-icon">',
            theme.icons.arrowLeft,
            '</span><span class="mobile-dropdown__back-text">',
            $(evt.currentTarget).siblings('.main-nav__link').html(),
            '</span>'
          ].join('')
        ).prependTo($newDropdown);
        this.$mobileDropdownContainer.append($newDropdown);
        setTimeout((function(){
          this.$mobileDropdownContainer.addClass('show-mobile-menu-level-2');
        }).bind(this), 10);
      } else {
        $dropdownToShow = $(evt.currentTarget).siblings('.main-nav__sub-dropdown');
        if($dropdownToShow.length) {
          // show level 3 dropdown
          var $newDropdown = $dropdownToShow.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-3">').parent();
          // add return link
          $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">').html(
            [
              '<span class="feather-icon">',
              theme.icons.arrowLeft,
              '</span><span class="mobile-dropdown__back-text">',
              $(evt.currentTarget).siblings('.main-nav__child-link').html(),
              '</span>'
            ].join('')
          ).prependTo($newDropdown);
          this.$mobileDropdownContainer.append($newDropdown);
          setTimeout((function(){
            this.$mobileDropdownContainer.addClass('show-mobile-menu-level-3');
          }).bind(this), 10);
        }
      }
    },

    /**
     * Event for closing a mobile dropdown menu
     */
    mobileMenuDropdownClose: function(evt) {
      evt.preventDefault();
      if(this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-3')) {
        // transition out level 3 dropdown
        this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-3');
        // remove menu element after transition time
        var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-3');
        setTimeout(function(){
          $toRemove.remove();
        }, this.mobileMenuTransitionTime);
      } else if(this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-2')) {
        // transition out level 2 dropdown
        this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-2');
        // remove menu element after transition time
        var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-2');
        setTimeout(function(){
          $toRemove.remove();
        }, this.mobileMenuTransitionTime);
      }
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      this.$container.off(this.namespace);
      $('.js-header-search-trigger', this.$container).off(this.namespace);
      $('.search-form__input', this.$container).off(this.namespace);
      $(document).off(this.namespace);
      $(window).off(this.namespace);
      this.$searchBar.off(this.namespace);
    }
  });

  return Header;
})();

// =require sections/footer.js
/**
 * Banner Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Banner
 */

theme.Banner = (function() {
  /**
   * Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Banner(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$slideshow = $('.slideshow', this.$container);
    this.stackBreakpoint = 840;

    // Initialise slideshow
    this.$slideshow.on('init', function(){
      $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
    }).slick({
      autoplay: this.$slideshow.hasClass('auto-play'),
      fade: this.$slideshow.data('slide-transition') == 'fade',
      infinite: true,
      useTransform: true,
      arrows: false,
      dots: this.$slideshow.find('.slide').length > 1,
      autoplaySpeed: this.$slideshow.data('slide-speed'),
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            fade: false
          }
        },
        {
          breakpoint: this.stackBreakpoint,
          settings: {
            fade: false,
            dots: this.$slideshow.find('.slide').length > 1
          }
        }
      ]
    });

    // Slideshow
    this.$companionContent = $('.banner-section__companion-column .overlay__inner', this.$container);
    if(this.$companionContent.children().length > 1) {
      this.assessCompanionCarousel.bind(this)();
      $(window).on('debouncedresize' + this.namespace, this.assessCompanionCarousel.bind(this));
    }
  };

  Banner.prototype = $.extend({}, Banner.prototype, {
    /**
    * Enable/disable carousel on companion content based on screen size
    */
    assessCompanionCarousel: function(){
      if($(window).width() < this.stackBreakpoint) {
        if(!this.$companionContent.hasClass('slick-slider')) {
          this.$companionContent.addClass('slick-slider').children().addClass('slide');
          this.$companionContent.parent().addClass('overlay--with-slider');
          this.$companionContent.slick({
            autoplay: true,
            fade: false,
            infinite: true,
            useTransform: true,
            arrows: false,
            dots: false,
            autoplaySpeed: 7000 // 7 seconds between slides
          });
        }
      } else {
        if(this.$companionContent.hasClass('slick-slider')) {
          this.$companionContent.slick('unslick');
          this.$companionContent.parent().removeClass('overlay--with-slider');
          this.$companionContent.removeClass('slick-slider').children().removeClass('slide');
        }
      }
    },

    /**
    * Event callback for Theme Editor `shopify:block:select` event
    */
    onBlockSelect: function(evt) {
      $(evt.target).closest('.slick-slider')
      .slick('slickGoTo', $(evt.target).data('slick-index'))
      .slick('slickPause');
    },

    /**
    * Event callback for Theme Editor `shopify:block:deselect` event
    */
   onBlockDeselect: function(evt) {
    $(evt.target).closest('.slick-slider')
      .slick('slickPlay');
   },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      this.$slideshow.slick('unslick').off('init');
      if(this.$companionContent.hasClass('slick-slider')) {
        this.$companionContent.slick('unslick');
      }
      $(window).off(this.namespace);
    }
  });

  return Banner;
})();

/**
 * Featured Collection Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace FeaturedCollection
 */

theme.FeaturedCollection = (function() {
  /**
   * FeaturedCollection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function FeaturedCollection(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$carousel = $('[data-grid-carousel]', this.$container);

    if(this.$carousel.length) {
      // switch to swiper classes
      this.$carousel
        .addClass('swiper-container')
        .children('.grid')
        .addClass('swiper-wrapper')
        .removeClass('grid')
        .children()
        .addClass('swiper-slide')
        .removeClass('grid__item');
      // init swiper
      this.carouselSwiper = new Swiper(this.$carousel, {
        init: false,
        //loop: true,
        //loopedSlides: 6,
        freeMode: false,
        slidesPerView: this.$carousel.data('grid-carousel-columns'),
        autoHeight: false,
        grabCursor: true,
        effect: 'slide',
        centeredSlides: false,
        spaceBetween: 14,
        navigation: {
          nextEl: $('.carousel-next', this.$container),
          prevEl: $('.carousel-prev', this.$container),
        },
        autoplay: false,
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          560: {
            spaceBetween: 12,
            freeMode: true,
            slidesPerView: 2
          }
        }
      });
      this.carouselSwiper.once('init', function(evt){
        this.$el.find('.swiper-slide-duplicate .lazyloading').addClass('lazyload');
      });
      this.carouselSwiper.init();
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  };

  FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      $(window).off(this.namespace);
      if(this.$carousel.length) {
        this.carouselSwiper.destroy();
      }
    }
  });

  return FeaturedCollection;
})();

/**
 * MiniCollectionList Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace MiniCollectionList
 */

theme.MiniCollectionList = (function() {
  /**
   * MiniCollectionList section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function MiniCollectionList(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$slideshow = $('.swiper-container', this.$container);

    /**
     * Swiper slideshow
     */
    var slidesperView = 4;
    if($('.sidebar').length) {
      slidesperView = 3;
    }

    var count = this.$slideshow.find('.swiper-slide', this.$container).length;
    if(count > 0) {
      this.mySwiper = new Swiper(this.$slideshow, {
        //loop: true,
        //loopedSlides: count,
        freeMode: true,
        slidesPerView: slidesperView,
        grabCursor: true,
        spaceBetween: 14,
        navigation: {
          nextEl: '.mini-collection-slider-next',
          prevEl: '.mini-collection-slider-prev',
        },
        breakpoints: {
          900: {
            slidesPerView: slidesperView - 1,
          },
          720: {
            slidesPerView: slidesperView - 2,
          },
          560: {
            slidesPerView: 2,
            spaceBetween: 12
          },
          490: {
            slidesPerView: 1
          }
        }
      });
    }
  };


  MiniCollectionList.prototype = $.extend({}, MiniCollectionList.prototype, {
    /**
    * Event callback for Theme Editor `shopify:block:select` event
    */
    onBlockSelect: function(evt) {
      if(this.mySwiper) {
        this.mySwiper.slideTo($(evt.target).data('swiper-index'), 1000);
      }
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      if(this.mySwiper) {
        this.mySwiper.destroy();
      }
    }
  });

  return MiniCollectionList;
})();

/**
 * Map Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Map
 */

theme.Map = (function() {
  /**
   * Map section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  var config = {
    zoom: 14,
    styles: {
      default: [],
      silver: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
      retro: [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}],
      dark: [{"elementType":"geometry","stylers":[{"color":"#212121"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}],
      night: [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}],
      aubergine: [{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}]
    }
  };

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };



  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) return;

    if (Shopify.designMode) {
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).show().after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    }
  };


  function Map(container) {

    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');
    this.style = this.$map.data('map-style');
    this.loaded = false;

    if (this.$map.length === 0 || typeof this.key !== 'string' || this.key === '') {
      return;
    }

    $(window).on('scroll' + this.namespace + ' load' + this.namespace, this.assessVisibility.bind(this));
    this.assessVisibility.bind(this)();
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }


  Map.prototype = $.extend({}, Map.prototype, {

    assessVisibility: function(){
      if( this.$container !== false
          && this.$container.offset().top < $(window).scrollTop() + $(window).height()
          && this.$container.offset().top + this.$container.outerHeight() > $(window).scrollTop() ) {
        $(window).off(this.namespace);
        theme.loadScriptOnce('https://maps.googleapis.com/maps/api/js?key=' + this.key, this.createMap.bind(this));
      }
    },

    createMap: function() {
      var $map = this.$map;
      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles[this.style],
              center: results[0].geometry.location,
              draggable: true,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
              zoomControl: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            // offset due to design
            map.panBy(0, 50);

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              map.panBy(0, 50);
              $map.removeAttr('style');
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      if(window.google) {
        google.maps.event.clearListeners(this.map, 'resize');
      }
      $(window).off(this.namespace);
    }
  });
  return Map;
})();

/**
 * Instagram Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Instagram
 */

theme.Instagram = (function() {
  /**
   * Instagram section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  function Instagram(container) {
    this.$container = $(container);
    this.$linkContainer = $('.willstagram-link-container', container);
    this.$slideshow = $('.swiper-container', this.$container);

    /**
     * Swiper slideshow
     */
    this.$slideshow.on('loaded.willstagram', function(){
      this.mySwiper = new Swiper(this, {
        slidesPerView: 4,
        grabCursor: true,
        spaceBetween: 14,
        navigation: {
          nextEl: '.instagram-slider-next',
          prevEl: '.instagram-slider-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 14
          },
          560: {
            slidesPerView: 2,
            spaceBetween: 12,
          }
        }
      });
    });

    this.loadInstagramWidgets.bind(this)();
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    loadInstagramWidgets: function() {
      var usingSwiper = this.$slideshow.length > 0;
      var $linkContainer = this.$linkContainer;
      $('.willstagram:not(.willstagram-placeholder)', this.$container).each(function(){
        var user_id = $(this).data('user_id');
        var tag = $(this).data('tag');
        var access_token = $(this).data('access_token');
        var count = $(this).data('count') || 10;
        var showHover = $(this).data('show-hover');
        var $willstagram = $(this);
        var url = '';
        if(typeof user_id != 'undefined') {
          url = 'https://api.instagram.com/v1/users/' + user_id + '/media/recent?count='+count;
        } else if(typeof tag != 'undefined') {
          url = 'https://api.instagram.com/v1/tags/' + tag + '/media/recent?count='+count;
        }
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          cache: false,
          url: url
          + (typeof access_token == 'undefined'? '' : ('&access_token='+access_token)),
          success: function(res) {
            if(typeof res.data != 'undefined') {
              var $itemContainer = $('<div class="willstagram__items">').appendTo($willstagram);
              if(usingSwiper) {
                $itemContainer.addClass('swiper-wrapper');
              }
              var limit = Math.min(20, res.data.length);
              for(var i = 0; i < limit; i++) {
                var photo_url = res.data[i].images.standard_resolution.url.replace('http:', '');
                var date = new Date(res.data[i].created_time * 1000);
                var $item = $([
                  '<div class="willstagram__item global-border-radius item--', i+1,
                  '"><a class="willstagram__link" target="_blank" href="',
                  res.data[i].link,
                  '" style="background-image:url(\'',
                  photo_url,
                  '\')"><img class="willstagram__img" src="',
                  photo_url,
                  '" /></a></div>'
                ].join(''));

                if(usingSwiper) {
                  $item.addClass('swiper-slide');
                }

                if(showHover) {
                  window.willstagramMaskCount = (window.willstagramMaskCount || 0) + 1;
                  var maskId = 'willstagram-svg-mask-' + window.willstagramMaskCount,
                      gradientId = 'willstagram-svg-grad-' + window.willstagramMaskCount;
                  $item.append([
                    '<div class="willstagram__overlay">',
                    '<div class="willstagram__desc">',
                    '<svg>',
                      '<defs>',
                        '<mask id="', maskId, '" maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse">',
                          '<linearGradient id="', gradientId, '" gradientUnits="objectBoundingBox" x2="0" y2="1">',
                            '<stop stop-color="white" stop-opacity="1" offset="0" />',
                            '<stop stop-color="white" stop-opacity="1" offset="0.6" />',
                            '<stop stop-color="white" stop-opacity="0" offset="1" />',
                          '</linearGradient>',
                          '<rect width="100%" height="100%" fill="url(#', gradientId, ')" />',
                        '</mask>',
                      '</defs>',
                      '<foreignObject width="100%" height="500" style="mask: url(#', maskId,')">',
                        '<div xmlns="http://www.w3.org/1999/xhtml">',
                          res.data[i].caption ? res.data[i].caption.text : '',
                        '</div>',
                      '</foreignObject>',
                    '</svg>',
                    '</div>',
                    '<div class="willstagram__likes">', res.data[i].likes ? ('❤ ' + res.data[i].likes.count) : '', '</div>',
                    '<div class="willstagram__date">', date.toLocaleDateString(), '</div>',
                    '</div>'
                  ].join(''));
                }
                $itemContainer.append($item);
              }

              $willstagram.trigger('loaded.willstagram');
              if(res.data.length > 0 && $linkContainer.length) {
                var username = res.data[0].user.username;
                var title_html = '@' + res.data[0].user.username;
                $linkContainer.html($('<a target="_blank">').attr('href', 'https://instagram.com/'+username).html(title_html));
              }
            } else if(typeof res.meta !== 'undefined' && typeof res.meta.error_message !== 'undefined') {
              $willstagram.append('<div class="willstagram__error">'+res.meta.error_message+'</div>');
            }
          }
        });
      });

      this.$slideshow.filter('.willstagram-placeholder').trigger('loaded.willstagram');
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      if(this.mySwiper) {
        this.mySwiper.destroy();
      }
    }

  });
  return Instagram;
})();

/**
 * Video Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Video
 */

theme.Video = (function() {
  /**
   * Video section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Video(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);

    var $iframeVideo = $(
      'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]',
      this.$container
    );
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's 'incorrect iFrame content on 'back'' bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });

    // Handle a cover image
    this.$cover = $('.video-container__cover', this.$container);
    if(this.$cover.length) {
      this.$container.on('click', '.video-container__play', this.coverPlayImage.bind(this));
    }
  }

  Video.prototype = $.extend({}, Video.prototype, {
    /**
     * Callback for clicking the cover image's play button
     */
    coverPlayImage: function(evt) {
      evt.preventDefault();
      var $videoContainer = $('.video-container', this.$container);
      var $videoTemplate = $('.video-container__video-template', this.$container);
      this.$cover.addClass('video-container__cover--playing');
      $videoContainer.append($videoTemplate.html());
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Video;
})();




/**
 * LogoList Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace LogoList
 */

theme.LogoList = (function() {
  /**
   * LogoList section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function LogoList(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$slideshow = $('.swiper-container', this.$container);

    /**
     * Swiper slideshow
     */
    var slidesPerView = this.$slideshow.data('items-per-row');
    var slideCount = this.$slideshow.find('.swiper-slide').length;
    if(slideCount > 0) {
      this.mySwiper = new Swiper(this.$slideshow, {
        //loop: true,
        //loopedSlides: 6,
        freeMode: true,
        slidesPerView: this.$slideshow.data('items-per-row'),
        grabCursor: true,
        spaceBetween: 14,
        navigation: {
          nextEl: '.logo-list-slider-next',
          prevEl: '.logo-list-slider-prev',
        },
        breakpoints: {
          767: {
            slidesPerView: 3
          },
          560: {
            slidesPerView: 3,
            spaceBetween: 12
          }
        }
      });
    }
  };

  LogoList.prototype = $.extend({}, LogoList.prototype, {
    /**
    * Event callback for Theme Editor `shopify:block:select` event
    */
    onBlockSelect: function(evt) {
      if(this.mySwiper) {
        this.mySwiper.slideTo($(evt.target).data('swiper-index'), 1000);
      }
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      if(this.mySwiper) {
        this.mySwiper.destroy();
      }
    }
  });

  return LogoList;
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * For collection pages
 *
 * @namespace collection-template
 */

theme.CollectionTemplate = (function() {

  var selectors = {
    sortBy: 'select[name="sort_by"]',
    styledSelect: '.styled-dropdown select',
    filterSelects: '.filter select',
    revealFilterButtons: '.collection-filter-control button'
  };

  /**
   * CollectionTemplate section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function CollectionTemplate(container) {
    this.$container = $(container);
    this.namespace = '.collectionTemplate';

    // change sort order
    this.$container.on('change' + this.namespace, selectors.sortBy, this.onSortByChange);

    // filtering
    this.$filters = this.$container.find(selectors.filterSelects);
    this.$filters.on('change' + this.namespace, this.onFilterChange.bind(this));

    // revealing filters on tablet/mobile
    this.$container.on('click' + this.namespace, selectors.revealFilterButtons, this.filterToggle);

    // style dropdowns
    theme.select2.init($(selectors.styledSelect, container));

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  CollectionTemplate.prototype = $.extend({}, CollectionTemplate.prototype, {
    /**
     * Event callback for when a tag filter changes
     */
    onFilterChange: function() {
      var path = this.$filters.first().data('filter-root');
      // build list of tags
      var tags = [];
      this.$filters.each(function(){
        if($(this).val().length > 0) {
          tags.push($(this).val());
        }
      });
      // add tags to collection path
      path += tags.join('+');
      // preserve sort order
      if(location.search.indexOf('sort_by') > -1) {
        var orderMatch = location.search.match(/sort_by=([^$&]*)/);
        if(orderMatch) {
          path += '?sort_by=' + orderMatch[1];
        }
      }
      window.location = path;
    },

    /**
     * Event callback for when the sort-by dropdown changes
     */
    onSortByChange: function() {
      var queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      queryParams.sort_by = $(this).val();
      location.search = $.param(queryParams);
    },

    /**
     * Function for revealing filter options
     */
    filterToggle: function(evt) {
      var $filterContainer = $('.filters-container');
      var whichSelected = $(this).data('collection-filter-reveal');
      var thisSelectedClass = 'show-' + whichSelected;
      if($filterContainer.hasClass(thisSelectedClass)) {
        $filterContainer.removeClass(thisSelectedClass);
      } else {
        $filterContainer.removeClass('show-filters show-sort').addClass(thisSelectedClass);
      }
      evt.target.blur();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      this.$filters.off(this.namespace);
      $(selectors.styledSelect, this.$container).select2('destroy');
      $(window).off(this.namespace);
    }
  });

  return CollectionTemplate;
})();

/**
* Page Story Template Section Script
* ------------------------------------------------------------------------------
*
* @namespace featured-collection */

theme.PageStoryTemplate = (function() {

  var selectors = {
    childSections: '[data-nested-section]'
  };

  /**
  * PageStoryTemplate section constructor. Runs on page load as well as Theme Editor
  * `section:load` events.
  * @param {string} container - selector for the section container DOM element
  */
  function PageStoryTemplate(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$childSections = $(selectors.childSections, container);

    // on first page load, all sections are loaded
    if(theme.pageStoryTemplateLoadedBefore) {
      // reload - trigger load on child sections
      this.$childSections.each(function(){
        var event = new CustomEvent('shopify:section:load', {
          bubbles: true,
          cancelable: true,
          detail: {
            sectionId: $(this).data('section-id')
          }
        });
        $(this)[0].dispatchEvent(event);
      });
    } else {
      // first load
      theme.pageStoryTemplateLoadedBefore = true;
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  PageStoryTemplate.prototype = $.extend({}, PageStoryTemplate.prototype, {

    onBlockSelect: function(evt) {
      $('html, body').stop(true).animate({
        scrollTop: Math.max(0, $(evt.target).offset().top - 100)
      }, 250);
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      $(window).off(this.namespace);
      this.$childSections.each(function(){
        var event = new CustomEvent('shopify:section:unload', {
          bubbles: true,
          cancelable: true,
          detail: {
            sectionId: $(this).data('section-id')
          }
        });
        $(this)[0].dispatchEvent(event);
      });
    }
  });

  return PageStoryTemplate;
})();

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * For the cart page
 *
 * @namespace cart-template
 */

theme.CartTemplate = (function() {

  var selectors = {
    termsCheckbox: '#terms'
  };

  /**
   * CartTemplate section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function CartTemplate(container) {
    this.$container = $(container);
    this.namespace = '.cartTemplate';

    // show/hide shipping estimates
    this.$container.on('click' + this.namespace, '.js-shipping-calculator-trigger', function(){
      var $this = $(this);
      var $parent = $this.parents('.shipping-calculator-container');
      $parent.toggleClass('calculator-open');
      if($parent.hasClass('calculator-open')){
        $this.children().text("hide shipping calculator");
        $parent.children('.shipping-calculator').slideDown(250);
      } else {
        $this.children().text("get shipping estimates");
        $parent.children('.shipping-calculator').slideUp(250);
      }
    });

    // show/hide the cart notes
    this.$container.on('click' + this.namespace, '.js-cart-notes-trigger', function(){
      var $this = $(this);
      var $parent = $this.parent('.cart-notes-container');
      $parent.toggleClass('notes-open');
      if($parent.hasClass('notes-open')){
        $this.children().text("");
        $parent.children('.cart-notes').slideDown(250);
      } else {
        $this.children().text("add special delivery instructions for georgiemane here.");
        $parent.children('.cart-notes').slideUp(250);
      }
    });

    // terms and conditions checkbox
    if($(selectors.termsCheckbox, container).length > 0) {
      $(document).on('click' + this.namespace, '[name="checkout"], a[href="/checkout"]', function() {
        if($(selectors.termsCheckbox + ':checked').length == 0) {
          alert(theme.strings.cartTermsNotChecked);
          return false;
        }
      });
    }

    // quantity adjustment
    if(this.$container.data('ajax-update')) {
      var updateCartFunction = this.updateCart;
      this.$container.on('keyup' + this.namespace + ' change' + this.namespace, '.quantity-adjuster__input', function(){
        if($(this).data('previousValue') && $(this).data('previousValue') == $(this).val()){
          return;
        }
        if($(this).val().length == 0 || $(this).val() == '0') {
          return;
        }
        updateCartFunction({
          line: $(this).data('line'),
          quantity: $(this).val()
        });
        $(this).data('previousValue', $(this).val());
      });

      this.$container.on('click' + this.namespace, '.quantity-adjuster__button--down, .quantity-adjuster__button--up', function(e){
        var $input = $(this).closest('.quantity-adjuster').find('.quantity-adjuster__input');
        if($(this).hasClass('quantity-adjuster__button--down')) {
          $input.val(parseInt($input.val()) - 1).trigger('change');
        } else {
          $input.val(parseInt($input.val()) + 1).trigger('change');
        }
        return false;
      });
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  CartTemplate.prototype = $.extend({}, CartTemplate.prototype, {
    /**
     * Function for changing the cart and updating the page
     */
    updateCart: function(params){
      if(window.cartXhr) {
        window.cartXhr.abort();
      }
      window.cartXhr = $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: params,
        dataType: 'json',
        success: function(data){
          // subtotal
          $('.cart-subtotal').html(
            $('<span class="theme-money">').html(slate.Currency.formatMoney(data.total_price, theme.moneyFormat))
          );

          // each line item
          $('.cart-item .cart-column--total .product-price[data-line]').each(function(){
            // line price
            var linePrice = data.items[$(this).data('line') - 1].line_price;
            $(this).html(
              $('<span class="theme-money">').html(slate.Currency.formatMoney(linePrice, theme.moneyFormat))
            );

            // minus visibility
            var quantity = data.items[$(this).data('line') - 1].quantity;
            var $item = $(this).closest('.cart-item');
            $item.find('.quantity-adjuster__button--down').toggleClass('quantity-adjuster__button--disabled', quantity < 2);
            var $input = $item.find('input');
            if($input.val() != quantity.toString()) {
              $input.val(quantity).data('previousValue', quantity.toString());
              alert(theme.strings.quantityTooHigh.replace(['{', '{ quantity }', '}'].join(''), quantity));
            }

            // plus visibility
            if($input.data('max') !== 'undefined' && $input.val() == $input.data('max')) {
              $item.find('.quantity-adjuster__button--up').addClass('quantity-adjuster__button--disabled');
            } else {
              $item.find('.quantity-adjuster__button--up').removeClass('quantity-adjuster__button--disabled');
            }
          });

          theme.checkCurrency();
        },
        error: function(data){
          console.log('Error processing update');
          console.log(data);
        },
        complete: function() {
          adjust_upsell();
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(window).off(this.namespace);
      $(document).off(this.namespace);
      this.$container.off(this.namespace);
    }
  });

  return CartTemplate;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


theme.namespaceFromSection = function(container) {
  return ['.', $(container).data('section-type'), $(container).data('section-id')].join('');
}

theme.openPageContentInLightbox = function(url) {
  $.get(url, function(data){
    var $content = $('#MainContent', $.parseHTML('<div>'+data+'</div>'));
    $.colorbox({
      transition: 'fade',
      html: '<div class="lightbox-content">' + $content.html() + '</div>',
      onOpen: theme.colorboxFadeTransOnOpen,
      onComplete: function(){
        theme.colorboxFadeTransOnComplete();
        // check any new inputs
        $('#cboxContent .input-wrapper input').trigger('inputstateEmpty');
      }
    });
  });
};

theme.styleVariantSelectors = function($els, data){
  $els.each(function(){
    if(typeof $(this).data('listed') != 'undefined') {
      // list options out, bound to the original dropdown
      $(this).clickyBoxes();

      // change swatch label on hover
      var $label = $(this).closest('.selector-wrapper').find('.variant-option-title');
      if($label.length) {
        $label.data('default-content', $label.html());
        $(this).siblings('.clickyboxes').on('change', function() {
          $label.data('default-content', $(this).find('a.active').data('value'));
        }).on('mouseenter', 'a', function(){
          $label.html($(this).data('value'));
        }).on('mouseleave', 'a', function(){
          $label.html($label.data('default-content'));
        });
      }

      if(data.options.length == 1) {
        for(var i=0; i<data.variants.length; i++) {
          var variant = data.variants[i];
          if(!variant.available) {
            $(this).siblings('.clickyboxes').find('a').filter(function(){
              return $(this).data('value') == variant.option1
            }).addClass('unavailable');
          }
        }
      }
    } else {
      // apply select2 to dropdown
      var config = {};
      theme.select2.init($(this), config);
    }
  });
}

theme.select2 = {
  init: function($els, config){
    var standardSelectOptions = {
      minimumResultsForSearch: Infinity
    };
    var swatchSelectOptions = {
      minimumResultsForSearch: Infinity,
      templateResult: theme.select2.swatchSelect2OptionTemplate,
      templateSelection: theme.select2.swatchSelect2OptionTemplate
    };
    if(typeof config !== 'undefined') {
      standardSelectOptions = $.extend(standardSelectOptions, config);
      swatchSelectOptions = $.extend(swatchSelectOptions, config);
    }
    $els.each(function(){
      $(this).select2($(this).data('colour-swatch') ? swatchSelectOptions : standardSelectOptions);
    });
  },
  swatchSelect2OptionTemplate: function(state) {
    if (state.id) {
      var colourKey = removeDiacritics(state.id).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '');
      return $([
        '<div class="swatch-option">',
        '<span class="swatch-option__nugget bg-', colourKey, '"></span>',
        '<span class="swatch-option__label">', state.text, '</span>',
        '</div>'
      ].join(''));
    } else {
      return $([
        '<div class="swatch-option swatch-option--all">',
        '<span class="swatch-option__label">', state.text, '</span>',
        '</div>'
      ].join(''));
    }
  }
};

theme.checkCurrency = function(){
  if(window.Currency && Currency.convertAll) {
    // set initial value for uninitialised prices
    $('.theme-money:not([data-currency-'+theme.Currency.shopCurrency+'])').each(function() {
      $(this).attr('data-currency-'+theme.Currency.shopCurrency, $(this).html());
    });
    // convert all
    Currency.convertAll(theme.Currency.shopCurrency, jQuery('[name=currencies]').val(), Currency.currencyContainer);
  }
}

theme.colorboxFadeTransOnOpen = function(){
  $('#colorbox').addClass('colorbox--hide');
};

theme.colorboxFadeTransOnComplete = function(){
  setTimeout(function(){
    $('#colorbox').addClass('colorbox--enable-trans');
    setTimeout(function(){
      $('#colorbox').removeClass('colorbox--hide');
      setTimeout(function(){
        $('#colorbox').removeClass('colorbox--enable-trans');
      }, 300);
    }, 20);
  }, 10);
};

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('sidebar', theme.Sidebar);
  sections.register('product', theme.Product);
  sections.register('header', theme.Header);
  sections.register('footer', theme.Footer);
  sections.register('banner', theme.Banner);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('mini-collection-list', theme.MiniCollectionList);
  sections.register('map', theme.Map);
  sections.register('instagram', theme.Instagram);
  sections.register('video', theme.Video);
  sections.register('logo-list', theme.LogoList);
  sections.register('collection-template', theme.CollectionTemplate);
  sections.register('page-story-template', theme.PageStoryTemplate);
  sections.register('cart-template', theme.CartTemplate);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  $('.footer-nav__accordion').on('click', '.js-footer-accordion-trigger', function(){
    $(this).siblings('.footer-nav__submenu').slideToggle(250);
    $(this).toggleClass('accordion-open');
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Quantity input wrapper
  $(document).on('change', '.quantity-proxy', function(){
    var value = $(this).val();
    var $input = $(this).siblings('[name="quantity"]');
    if(value == '10+') {
      $input.val('10').closest('.quantity-wrapper').addClass('hide-proxy');
      setTimeout(function(){
        $input.select().focus();
      }, 10);
    } else {
      $input.val(value);
    }
  });
});

theme.initProductTitleAlignmentWatcher = function($container, namespace){
  var $productGrids = $('.product-grid', $container);
  if($productGrids.length) {
    theme.alignProductImageTitles.bind($productGrids)();
    $(window).on('debouncedresize' + namespace, theme.alignProductImageTitles.bind($productGrids));
  }
};

theme.alignProductImageTitles = function(){
  $(this).each(function(){
    var tallest = 0;
    $('.product-block__primary-image', this).each(function(){
      var h = $(this).height();
      if(h > tallest) {
        tallest = h;
      }
    });
    $('.product-block__image', this).css('min-height', tallest);
  });
};


// jQuery('#accordion, #accordion-2').on('hidden.bs.collapse', function () {
// console.log('closed');
// })

})(theme.jQuery);

//CD swatch wrapper
jQuery(function() {
  jQuery('.swatch-wrapper .swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('[data-single-option-selector]')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
});

//CD
$(document).on('click','[data-toggle="cart-drawer"]',function(e){
  e.preventDefault();
  var $circle;
  $('body').addClass('sidecart-opened');
  setTimeout(function(){
    $('.sidebar-shipping').each(function(){
      $circle = $(this).find('.circleFill');
      if($circle.length) {
        $circle.css('stroke-dashoffset',$circle.attr('data'));
      }
    });
  },1000);
  $.getJSON('/cart.js',function(cart){
    var cart_total_price = cart.total_price;
    new_cart_progress_bar(cart_total_price);   
  });
});

$(document).on('click','[data-action="close-sidebar"]',function(e){
  e.preventDefault();
  $('body').removeClass('sidecart-opened scrolled');
  $('#shopify-section-header').removeClass('nav-up').addClass('nav-down');
  
  if(location.pathname.indexOf('build-your-own-bundle') >= 0) {
    $('.buy_box').removeClass('open-box');
    if($('.added_products').is(':empty')) {
      $('.bundle_toggle').removeClass('active');
    } else {
      $('.bundle_toggle').addClass('active');
    }
  }
});

$('.sidebar-overlay').on('click',function(e){
  $('body').removeClass('sidecart-opened scrolled');
  $('#shopify-section-header').removeClass('nav-up').addClass('nav-down');
});

async function gwpItemAdd(data) {
  try {
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  } catch (error) {
    console.error('Error adding free product:', error);
  }
}

async function gwpItemRemove(variant_id) {
  try {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variant_id,
        quantity: 0
      })
    });
  } catch (error) {
    console.error('Error adding free product:', error);
  }
}


let cartRequest, innerCartRequest;
function refreshSideCart(open_drawer = true) {
  var barExist = false;
  if(open_drawer) {
    if(!$('body').hasClass('sidecart-opened')) $('body').addClass('sidecart-opened');
  }
  cartRequest = $.getJSON('/cart.js',async function(cart){
    if(cartRequest) cartRequest.abort();
    if(cart.item_count > 0) {
      $('.cart').addClass('cart--show-indicator');
    } else {
      $('.cart').removeClass('cart--show-indicator');
    }
    $('.header__cart-count').text(cart.item_count);

    var gwp_counter = 0;
    var upsell = window.upsell,upsell_price;
    var upsell_id = upsell.product_id,upsell_exist = false; 
    if(upsell.enable == 'true' && upsell_id != '') {
      upsell_price = parseInt(upsell.threshold);
      upsell_price = isNaN(upsell_price)?0:upsell_price;
      upsell_price = upsell_price*100;
      
      cart.items.forEach(function(item,index){
        if(item.variant_id == upsell_id) {
          upsell_exist = true;
          return false;
        }
      });

      var post_data = {
        id: upsell_id,
        quantity: 1
      };
      if(upsell.original_price != '') {
        post_data['properties'] = {
          "Original price": upsell.original_price
        }
      }
      
      if(cart.total_price >= upsell_price) {
        if(!upsell_exist) {
          gwp_counter++;
          await gwpItemAdd(post_data);
          // $.ajax({
          //   url: '/cart/add.js',
          //   type: 'post',
          //   dataType: 'json',
          //   data: post_data,
          //   success: function(){
          //     refreshSideCart();
          //   }
          // });
        }
      } else {
        if(upsell_exist) {
          gwp_counter++;
          await gwpItemRemove(upsell_id);
          // $.ajax({
          //   url: '/cart/change.js',
          //   type: 'post',
          //   dataType: 'json',
          //   data: {
          //     id: upsell_id,
          //     quantity: 0
          //   },
          //   success: function(){
          //     refreshSideCart();
          //   }
          // });
        }
      }
    }else{
      cart.items.forEach(function(item,index){
        if(item.variant_id == upsell_id) {
          upsell_exist = true;
          return false;
        }
      });
      if(upsell_exist) {
        gwp_counter++;
        await gwpItemRemove(upsell_id);
        // $.ajax({
        //   url: '/cart/change.js',
        //   type: 'post',
        //   dataType: 'json',
        //   data: {
        //     id: upsell_id,
        //     quantity: 0
        //   },
        //   success: function(){
        //     refreshSideCart();
        //   }
        // });
      }
    }

    // CD Arshit
    var thresholds = ['third_threshhold','third_b_threshhold'];
    $('.sidebar-inner .sidebar-footer-wrap .sidebar-chkout').addClass('btn_disabled');
    for (const threshold of thresholds) {
      var third_threshhold = window[threshold],  
          third_threshhold_price,
          third_threshhold_id = third_threshhold.product_id,
          free_original_price = third_threshhold.original_price,
          third_threshhold_exist = false; 

      if(innerCartRequest) innerCartRequest.abort();
      innerCartRequest = new AbortController();
      const signal = innerCartRequest.signal;

      let _cart = await fetch("/cart.js", { signal }).then((response) => response.json());
      if(third_threshhold.enable == 'true' && third_threshhold_id != '') {
        third_threshhold_price = parseInt(third_threshhold.threshold);
        third_threshhold_price = isNaN(third_threshhold_price)?0:third_threshhold_price;
        third_threshhold_price = third_threshhold_price*100;

        var post_data = {
          id: third_threshhold_id,
          quantity: 1
        }
        if(free_original_price != '') {
          post_data['properties'] = {
            "Original price": free_original_price
          }
        }

        _cart.items.forEach(function(item,index){
          if(item.variant_id == third_threshhold_id) {
            third_threshhold_exist = true;
            return false;
          }
        });

        if(_cart.total_price >= third_threshhold_price) {
          if(!third_threshhold_exist) {
            gwp_counter++;
            await gwpItemAdd(post_data);
          } 
        } else {
          if(third_threshhold_exist) {
            gwp_counter++;
            await gwpItemRemove(third_threshhold_id);
          }
        }
      } else {
        _cart.items.forEach(function(item,index){
          if(item.variant_id == third_threshhold_id) {
            third_threshhold_exist = true;
            return false;
          }
        });
        if(third_threshhold_exist) {
          gwp_counter++;
          await gwpItemRemove(third_threshhold_id);
        }
      }
    }
    if(gwp_counter > 0) refreshSideCart();
    $('.sidebar-inner .sidebar-footer-wrap .sidebar-chkout').removeClass('btn_disabled');
    
    $.ajax({
      url: '/cart?view=side-cart',
      dataType: 'html',
      success: function(html){
        var $html = $.parseHTML(html);
        if(cart.item_count > 0) {

          // CD Nirav
          var new_threshhold_pro_bar = false,
              cart_total_price = cart.total_price;
          
          if($('.new_threshhold').length){
            new_threshhold_pro_bar = true;
            new_cart_progress_bar(cart_total_price);
          }
          
          var _third_threshhold = window.third_threshhold,
              _third_threshhold_id = _third_threshhold.product_id; 
          
          if(!new_threshhold_pro_bar){
            if($('.new_threshhold').length == 0){
              $('<div class="new_thresh_design">').insertAfter('.sidebar-header');
              if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
                $('<div class="new_threshhold third_threshhold_enabled hide" style="display: none !important;">').insertAfter('.sidebar-header');
              }else{
                $('<div class="new_threshhold hide" style="display: none !important;">').insertAfter('.sidebar-header');
              }
            }
            $('.new_threshhold').append($(html).find('.threshhold_details_inner'));
            $('.new_threshhold').append($(html).find('.threshhold_msg'));

            $('.new_thresh_design').append($(html).find('.threshhold_msg.center'));
            $('.new_thresh_design').append($(html).find('.thresh_inner'));
            
            new_cart_progress_bar(cart_total_price);
          }
          
          if($('.sidebar-inner').find('.jsShipBar').length || $('.sidebar-inner').find('.jsUpsellBar').length) {
            barExist = true;
            $('.jsContent').html($(html).find('.jsContent').html());
            if($('.sidebar-inner').find('.jsShipBar').length) {
              $('.jsShip .circleFill').attr('data',$(html).find('.jsShip .circleFill').attr('data'));
              $('.jsShip .circleFill').css('stroke-dashoffset',$(html).find('.jsShip .circleFill').attr('data'));
              $('.jsShipMsg').html($(html).find('.jsShipMsg').html());
            }
            if($('.sidebar-inner').find('.jsUpsellBar').length) {
              $('.jsUpsell .circleFill').attr('data',$(html).find('.jsUpsell .circleFill').attr('data'));
              $('.jsUpsell .circleFill').css('stroke-dashoffset',$(html).find('.jsUpsell .circleFill').attr('data'));
              $('.jsUpsellMsg').html($(html).find('.jsUpsellMsg').html());
            }
          }
          if(!barExist) {
            if($(html).find('.jsShip').length) {
              barExist = true;
              if($('.bar-wrap').length == 0) $('<div class="bar-wrap">').insertAfter('.sidebar-header');
              $('.bar-wrap').append($(html).find('.jsShipBar'));
              $('.jsShip .circleFill').css('stroke-dashoffset',$(html).find('.bar-wrap').attr('data'));
              $('.jsShip .circleFill').attr('data',$(html).find('.jsShip .circleFill').attr('data'));
              setTimeout(function(){
                $('.jsShip .circleFill').css('stroke-dashoffset',$(html).find('.jsShip .circleFill').attr('data'));
              },1000);
              $('.jsShipMsg').html($(html).find('.jsShipMsg').html());
            }
            if($(html).find('.jsUpsell').length) {
              barExist = true;
              if($('.bar-wrap').length == 0) $('<div class="bar-wrap">').insertAfter('.sidebar-header'); 
              $('.bar-wrap').append($(html).find('.jsUpsellBar'));
              $('.jsUpsell .circleFill').css('stroke-dashoffset',$(html).find('.bar-wrap').attr('data'));
              $('.jsUpsell .circleFill').attr('data',$(html).find('.jsUpsell .circleFill').attr('data'));
              setTimeout(function(){
                $('.jsUpsell .circleFill').css('stroke-dashoffset',$(html).find('.jsUpsell .circleFill').attr('data'));
              },1000);
              $('.jsUpsellMsg').html($(html).find('.jsUpsellMsg').html());
            }
          }
          if(barExist) {
            $('.jsContent').html($(html).find('.jsContent').html());
          } else {
            $('.sidebar-inner').html($html[1].innerHTML);
          }
        } else {
          $('.sidebar-inner').html($html[1].innerHTML);

          // CD Arshit (Close Side Cart Automatically)
          setTimeout(function() {
            $('.sidebar-overlay').click();
          }, 500);
          
        }
        
        /* var third_threshhold = window.third_threshhold,
            third_threshhold_price,
            third_threshhold_id = third_threshhold.product_id,
            free_original_price = third_threshhold.original_price,
            third_threshhold_exist = false; 
        if(third_threshhold.enable == 'true' && third_threshhold_id != '') {
          third_threshhold_price = parseInt(third_threshhold.threshold);
          third_threshhold_price = isNaN(third_threshhold_price)?0:third_threshhold_price;
          third_threshhold_price = third_threshhold_price*100;
          
          cart.items.forEach(function(item,index){
            if(item.variant_id == third_threshhold_id) {
              third_threshhold_exist = true;
              return false;
            }
          });

          let _data_ = {
            id: third_threshhold_id,
            quantity: 1
          }
          if(free_original_price != '') {
            _data_['properties'] = {
              "Original price": free_original_price
            }
          }
          if(third_threshhold_id == '41514377085001'){
            _data_ = {
              id: third_threshhold_id,
              quantity: 1,
              properties: {
                "1": "50ml hair mask",
                "2": "50ml shampoo",
                "3": "50ml conditioner",
                "4": "20ml anti-frizz serum",
                "5": "20ml hair growth spray"
              }
            }
          }
          
          if(cart.total_price >= third_threshhold_price) {
            if(!third_threshhold_exist) {
              $.ajax({
                url: '/cart/add.js',
                type: 'post',
                dataType: 'json',
                data: _data_,
                success: function(){
                  refreshSideCart();
                }
              });
            }
          } else {
            if(third_threshhold_exist) {
              $.ajax({
                url: '/cart/change.js',
                type: 'post',
                dataType: 'json',
                data: {
                  id: third_threshhold_id,
                  quantity: 0
                },
                success: function(){
                  refreshSideCart();
                }
              });
            }
          }
        }else{
          cart.items.forEach(function(item,index){
            if(item.variant_id == third_threshhold_id) {
              third_threshhold_exist = true;
              return false;
            }
          });
          if(third_threshhold_exist) {
            $.ajax({
              url: '/cart/change.js',
              type: 'post',
              dataType: 'json',
              data: {
                id: third_threshhold_id,
                quantity: 0
              },
              success: function(){
                refreshSideCart();
              }
            });
          }
        } */
        
      }
    });
  });
}

// function refreshSideCart(open_drawer = true) {
//   var barExist = false;
//   if(open_drawer) {
//     if(!$('body').hasClass('sidecart-opened')) $('body').addClass('sidecart-opened');
//   }
//   $.getJSON('/cart.js',function(cart){
//     if(cart.item_count > 0) {
//       $('.cart').addClass('cart--show-indicator');
//     } else {
//       $('.cart').removeClass('cart--show-indicator');
//     }
//     $('.header__cart-count').text(cart.item_count);
//     $.ajax({
//       url: '/cart?view=side-cart',
//       dataType: 'html',
//       success: async function(html){
//         var $html = $.parseHTML(html);
//         if(cart.item_count > 0) {

//           // CD Nirav
//           var new_threshhold_pro_bar = false,
//               cart_total_price = cart.total_price;
          
//           if($('.new_threshhold').length){
//             new_threshhold_pro_bar = true;
//             new_cart_progress_bar(cart_total_price);
//           }
          
//           var _third_threshhold = window.third_threshhold,
//               _third_threshhold_id = _third_threshhold.product_id; 
          
//           if(!new_threshhold_pro_bar){
//             if($('.new_threshhold').length == 0){
//               $('<div class="new_thresh_design">').insertAfter('.sidebar-header');
//               if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
//                 $('<div class="new_threshhold third_threshhold_enabled hide" style="display: none !important;">').insertAfter('.sidebar-header');
//               }else{
//                 $('<div class="new_threshhold hide" style="display: none !important;">').insertAfter('.sidebar-header');
//               }
//             }
//             $('.new_threshhold').append($(html).find('.threshhold_details_inner'));
//             $('.new_threshhold').append($(html).find('.threshhold_msg'));

//             $('.new_thresh_design').append($(html).find('.threshhold_msg.center'));
//             $('.new_thresh_design').append($(html).find('.thresh_inner'));
            
//             new_cart_progress_bar(cart_total_price);
//           }
          
//           if($('.sidebar-inner').find('.jsShipBar').length || $('.sidebar-inner').find('.jsUpsellBar').length) {
//             barExist = true;
//             $('.jsContent').html($(html).find('.jsContent').html());
//             if($('.sidebar-inner').find('.jsShipBar').length) {
//               $('.jsShip .circleFill').attr('data',$(html).find('.jsShip .circleFill').attr('data'));
//               $('.jsShip .circleFill').css('stroke-dashoffset',$(html).find('.jsShip .circleFill').attr('data'));
//               $('.jsShipMsg').html($(html).find('.jsShipMsg').html());
//             }
//             if($('.sidebar-inner').find('.jsUpsellBar').length) {
//               $('.jsUpsell .circleFill').attr('data',$(html).find('.jsUpsell .circleFill').attr('data'));
//               $('.jsUpsell .circleFill').css('stroke-dashoffset',$(html).find('.jsUpsell .circleFill').attr('data'));
//               $('.jsUpsellMsg').html($(html).find('.jsUpsellMsg').html());
//             }
//           }
//           if(!barExist) {
//             if($(html).find('.jsShip').length) {
//               barExist = true;
//               if($('.bar-wrap').length == 0) $('<div class="bar-wrap">').insertAfter('.sidebar-header');
//               $('.bar-wrap').append($(html).find('.jsShipBar'));
//               $('.jsShip .circleFill').css('stroke-dashoffset',$(html).find('.bar-wrap').attr('data'));
//               $('.jsShip .circleFill').attr('data',$(html).find('.jsShip .circleFill').attr('data'));
//               setTimeout(function(){
//                 $('.jsShip .circleFill').css('stroke-dashoffset',$(html).find('.jsShip .circleFill').attr('data'));
//               },1000);
//               $('.jsShipMsg').html($(html).find('.jsShipMsg').html());
//             }
//             if($(html).find('.jsUpsell').length) {
//               barExist = true;
//               if($('.bar-wrap').length == 0) $('<div class="bar-wrap">').insertAfter('.sidebar-header'); 
//               $('.bar-wrap').append($(html).find('.jsUpsellBar'));
//               $('.jsUpsell .circleFill').css('stroke-dashoffset',$(html).find('.bar-wrap').attr('data'));
//               $('.jsUpsell .circleFill').attr('data',$(html).find('.jsUpsell .circleFill').attr('data'));
//               setTimeout(function(){
//                 $('.jsUpsell .circleFill').css('stroke-dashoffset',$(html).find('.jsUpsell .circleFill').attr('data'));
//               },1000);
//               $('.jsUpsellMsg').html($(html).find('.jsUpsellMsg').html());
//             }
//           }
//           if(barExist) {
//             $('.jsContent').html($(html).find('.jsContent').html());
//           } else {
//             $('.sidebar-inner').html($html[1].innerHTML);
//           }
//         } else {
//           $('.sidebar-inner').html($html[1].innerHTML);

//           // CD Arshit (Close Side Cart Automatically)
//           setTimeout(function() {
//             $('.sidebar-overlay').click();
//           }, 500);
          
//         }
        
//         var upsell = window.upsell,upsell_price;
//         var upsell_id = upsell.product_id,upsell_exist = false; 
//         if(upsell.enable == 'true' && upsell_id != '') {
//           upsell_price = parseInt(upsell.threshold);
//           upsell_price = isNaN(upsell_price)?0:upsell_price;
//           upsell_price = upsell_price*100;
          
//           cart.items.forEach(function(item,index){
//             if(item.variant_id == upsell_id) {
//               upsell_exist = true;
//               return false;
//             }
//           });

//           var post_data = {
//             id: upsell_id,
//             quantity: 1
//           };
//           if(upsell.original_price != '') {
//             post_data['properties'] = {
//               "Original price": upsell.original_price
//             }
//           }
          
//           if(cart.total_price >= upsell_price) {
//             if(!upsell_exist) {
//               $.ajax({
//                 url: '/cart/add.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: post_data,
//                 success: function(){
//                   refreshSideCart();
//                 }
//               });
//             }
//           } else {
//             if(upsell_exist) {
//               $.ajax({
//                 url: '/cart/change.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: {
//                   id: upsell_id,
//                   quantity: 0
//                 },
//                 success: function(){
//                   refreshSideCart();
//                 }
//               });
//             }
//           }
//         }else{
//           cart.items.forEach(function(item,index){
//             if(item.variant_id == upsell_id) {
//               upsell_exist = true;
//               return false;
//             }
//           });
//           if(upsell_exist) {
//             $.ajax({
//               url: '/cart/change.js',
//               type: 'post',
//               dataType: 'json',
//               data: {
//                 id: upsell_id,
//                 quantity: 0
//               },
//               success: function(){
//                 refreshSideCart();
//               }
//             });
//           }
//         }

//         // CD Arshit
//         var thresholds = ['third_threshhold','third_b_threshhold'];
//         var gwp_counter = 0;
//         $('.sidebar-inner .sidebar-footer-wrap .sidebar-chkout').addClass('btn_disabled');
//         for (const threshold of thresholds) {
//           var third_threshhold = window[threshold],  
//               third_threshhold_price,
//               third_threshhold_id = third_threshhold.product_id,
//               free_original_price = third_threshhold.original_price,
//               third_threshhold_exist = false; 

//           if(third_threshhold.enable == 'true' && third_threshhold_id != '') {
//             third_threshhold_price = parseInt(third_threshhold.threshold);
//             third_threshhold_price = isNaN(third_threshhold_price)?0:third_threshhold_price;
//             third_threshhold_price = third_threshhold_price*100;

//             var post_data = {
//               id: third_threshhold_id,
//               quantity: 1
//             }
//             if(free_original_price != '') {
//               post_data['properties'] = {
//                 "Original price": free_original_price
//               }
//             }

//             cart.items.forEach(function(item,index){
//               if(item.variant_id == third_threshhold_id) {
//                 third_threshhold_exist = true;
//                 return false;
//               }
//             });

//             if(cart.total_price >= third_threshhold_price) {
//               if(!third_threshhold_exist) {
//                 gwp_counter++;
//                 await gwpItemAdd(post_data);
//               } 
//             } else {
//               if(third_threshhold_exist) {
//                 gwp_counter++;
//                 await gwpItemRemove(third_threshhold_id);
//               }
//             }
//           } else {
//             cart.items.forEach(function(item,index){
//               if(item.variant_id == third_threshhold_id) {
//                 third_threshhold_exist = true;
//                 return false;
//               }
//             });
//             if(third_threshhold_exist) {
//               gwp_counter++;
//               await gwpItemRemove(third_threshhold_id);
//             }
//           }
//         }
//         if(gwp_counter > 0) refreshSideCart();
//         $('.sidebar-inner .sidebar-footer-wrap .sidebar-chkout').removeClass('btn_disabled');
        
//         /* var third_threshhold = window.third_threshhold,
//             third_threshhold_price,
//             third_threshhold_id = third_threshhold.product_id,
//             free_original_price = third_threshhold.original_price,
//             third_threshhold_exist = false; 
//         if(third_threshhold.enable == 'true' && third_threshhold_id != '') {
//           third_threshhold_price = parseInt(third_threshhold.threshold);
//           third_threshhold_price = isNaN(third_threshhold_price)?0:third_threshhold_price;
//           third_threshhold_price = third_threshhold_price*100;
          
//           cart.items.forEach(function(item,index){
//             if(item.variant_id == third_threshhold_id) {
//               third_threshhold_exist = true;
//               return false;
//             }
//           });

//           let _data_ = {
//             id: third_threshhold_id,
//             quantity: 1
//           }
//           if(free_original_price != '') {
//             _data_['properties'] = {
//               "Original price": free_original_price
//             }
//           }
//           if(third_threshhold_id == '41517870612558'){
//             _data_ = {
//               id: third_threshhold_id,
//               quantity: 1,
//               properties: {
//                 "1": "50ml hair mask",
//                 "2": "50ml shampoo",
//                 "3": "50ml conditioner",
//                 "4": "20ml anti-frizz serum",
//                 "5": "20ml hair growth spray"
//               }
//             }
//           }
          
//           if(cart.total_price >= third_threshhold_price) {
//             if(!third_threshhold_exist) {
//               $.ajax({
//                 url: '/cart/add.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: _data_,
//                 success: function(){
//                   refreshSideCart();
//                 }
//               });
//             }
//           } else {
//             if(third_threshhold_exist) {
//               $.ajax({
//                 url: '/cart/change.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: {
//                   id: third_threshhold_id,
//                   quantity: 0
//                 },
//                 success: function(){
//                   refreshSideCart();
//                 }
//               });
//             }
//           }
//         }else{
//           cart.items.forEach(function(item,index){
//             if(item.variant_id == third_threshhold_id) {
//               third_threshhold_exist = true;
//               return false;
//             }
//           });
//           if(third_threshhold_exist) {
//             $.ajax({
//               url: '/cart/change.js',
//               type: 'post',
//               dataType: 'json',
//               data: {
//                 id: third_threshhold_id,
//                 quantity: 0
//               },
//               success: function(){
//                 refreshSideCart();
//               }
//             });
//           }
//         } */
        
//       }
//     });
//   });
// }

function updateQty(qty,line){
  var $line = $('.sidebar-item[data-index="'+line+'"]');
  $line.addClass('processing');
  $.ajax({
    url: '/cart/change.js',
    type: 'post',
    dataType: 'json',
    data: {
      line: line,
      quantity: qty
    },
    complete: function(){
      refreshSideCart();
    }
  });
}

$(document).on('click','.jsQtyBtn',function(){
  var $qty = $(this).parents('.jsQtyWrap').find('.jsQty');
  var qty = parseInt($qty.val());
  qty = (isNaN(qty))?1:qty;
  if($(this).attr('data-action') == 'minus') {
    if(qty >= 0)qty--;
  } else {
    qty++;
  }
  $qty.val(qty);
  updateQty(qty,$(this).parents('.jsQtyWrap').attr('data-line'));
});

$(document).on('change','.jsQty',function(){
  var qty = parseInt($(this).val());
  qty = (isNaN(qty))?1:qty;
  $(this).val(qty);
  updateQty(qty,$(this).parents('.jsQtyWrap').attr('data-line'));
});

$(document).on('click','.jsItemRemove',function(e){
  e.preventDefault();
  updateQty(0,$(this).attr('data-line'));
});

$(document).on('sideCartRefresh',function(){
  if($('.sidebar-inner').length) refreshSideCart();
});

$(document).on('click','.btnUpsellAdd',function(){
  var updates = {};
  if($(this).attr('data-id') != '' && $(this).attr('data-alt') != '' && $(this).attr('data-qty') != '') {
    $this = $(this);
    // updates[$(this).attr('data-id')] = parseInt($(this).attr('data-qty'));
    updates[$(this).attr('data-alt')] = 0;
    $(this).parents('.upsell-item').addClass('processing');
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: {
        updates: updates
      },
      success: function(){},
      complete: function(){
        let post_data = {
          id: $this.attr("data-id"),
          quantity: $this.attr("data-qty")
        }
        if($this.attr("data-original-price") != '') {
          post_data['properties'] = {
            "Original price": $this.attr("data-original-price")
          }
        }
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: post_data,
          success: function() {},
          complete: function() {
            refreshSideCart();      
          }
        });
      }
    });
  }
});

$(document).on('click','.sidebar-chkout',function(){
  if($(this).hasClass('btnSubscrptn')) {
	location.href = reChargeProcessCart();
  } else {
    location.href='/checkout';
  }
});

function set_compare_price($this, qty) {
  var $form = $this.parents("form");
  var $original_price = $form.find('.original_price');
  if($original_price.length) {
    var compare_price = parseInt($original_price.attr("data"));
    compare_price = compare_price * qty;

    var compare_price_elem = document.createElement("DIV");
    compare_price_elem.innerHTML = slate.Currency.formatMoney(compare_price, theme.moneyFormat);

    $original_price.val(compare_price_elem.textContent);
  }
}

$(document).on('click','.qtyBtn',function(){
  var $qty = $(this).parents('.productQty').find('.inputQty');
  var qty = parseInt($qty.val());
  var min = (typeof $qty.attr('min') == 'undefined')?1:parseInt($qty.attr('min'));
  qty = (isNaN(qty))?1:qty;
  if($(this).attr('data-action') == 'minus') {
    if(qty > min) qty--;
  } else {
    qty++;
  }
  $qty.val(qty);

  set_compare_price($(this), qty);

  // CD Arshit New Changes
  replace_minus_icon($qty, qty);
  
});

$(document).on('change','.inputQty',function(){
  var qty = parseInt($(this).val());
  qty = (isNaN(qty))?1:qty;
  $(this).val(qty);

  set_compare_price($(this), qty);

  // CD Arshit New Changes
  replace_minus_icon($(this), qty);
  
});

$('.jsSwatch').on('change',function(){
  var product = JSON.parse($(this).parents('form.produtForm').attr('data'));
  var variant, variant_id = $(this).filter(':checked').prop('value');
  var $product = $('#productBlock-'+product.id);
  var btnTxt = $product.find('.btnAddToCart').attr('data-label');
  for(var i = 0;i < product.variants.length;i++) {
    if(variant_id == product.variants[i].id) {
      variant = product.variants[i];
      break;
    }
  }
  if(typeof variant != 'undefined') {
    $product.find('.regularPrice').html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
    var $original_price = $product.find('.produtForm .original_price');
    if(variant.compare_at_price > variant.price) {
      var compare_price_elem = document.createElement("DIV");
      var qty = parseInt($product.find("input[name='quantity']").val());
      compare_price_elem.innerHTML = slate.Currency.formatMoney((variant.compare_at_price * qty), theme.moneyFormat);
      
      $product.find('.regularPrice').addClass('product-price__reduced').removeClass('product-price__amount');
      $product.find('.comparePrice').html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass('hide');

      if($original_price.length) {
        $original_price.attr("data",variant.compare_at_price);
        $original_price.val(compare_price_elem.textContent);
      } else {
        $product.find('.produtForm').append('<input type="hidden" name="properties[Original price]" class="original_price" data="'+variant.compare_at_price+'" value="'+compare_price_elem.textContent+'" />');
      }
    } else {
      $product.find('.regularPrice').removeClass('product-price__reduced').addClass('product-price__amount');
      $product.find('.comparePrice').addClass('hide');

      if($original_price.length) $original_price.remove();
    }
    $product.find('._btn_price').html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
    theme.checkCurrency(); 
    
    if(variant.available) {
      $product.find('.btnAddToCart').removeClass('btnDisabled');
      $product.find('.btnAddToCart ._btn_text').text(btnTxt).removeClass('btnDisabled');
    } else {
      $product.find('.btnAddToCart').addClass('btnDisabled');
      $product.find('.btnAddToCart ._btn_text').text('Sold Out').addClass('btnDisabled');
    }
    $product.find('input[name="id"]').val(variant.id);
  }
});

$('.produtForm').on('submit',function(e){
  e.preventDefault();
  var $this = $(this);
  var $btn = $this.find('.btnAddToCart');
  var btnTxt = $btn.attr('data-label');
  if(typeof btnTxt == 'undefined') btnTxt = 'Add to cart';
  $btn.text('Adding..').addClass('btnDisabled');
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    data: $this.serialize(),
    success: function(){
      $(document).trigger('sideCartRefresh');
    },
    complete: function(){
      $btn.text(btnTxt).removeClass('btnDisabled');
    }
  });
});

function setCounterDate(loopTime,toNext = false) {
  var today = new Date();
  if(toNext) {
    today.setDate(today.getDate() + 1);
  }
  var dd = (today.getDate() < 10)?'0'+today.getDate():today.getDate();
  var mm = ((today.getMonth()+1) < 10)?'0'+(today.getMonth()+1):(today.getMonth()+1); 
  var yyyy = today.getFullYear();
  return yyyy+'-'+mm+'-'+dd+'T'+loopTime;
}

if($('.timerCountdown').length) {
  var timeHTML = '<span class="p-days p-time">%D</span><span class="p-hours p-time">%H</span><span class="p-minutes p-time">%M</span><span class="p-sec p-time">%S</span>';

  var $timer = $('.timerSec:not(.timerSmall)');
  if($(window).width() < 800) $timer = $('.timerSec.timerSmall');
  
  if($('.timerCountdown').attr('infinite') == 'true' && $('.timerCountdown').attr('loop-time').trim() != '') {
    var loopTime = $('.timerCountdown').attr('loop-time').trim();
    var currDate = new Date();
    var loopDate = setCounterDate(loopTime);
    loopDate = new Date(loopDate);
    if(currDate > loopDate) {
      loopDate = setCounterDate(loopTime,true);
      loopDate = new Date(loopDate);
    } 
    
    $('.timerCountdown').countdown(loopDate,function(event) {
      $(this).html(event.strftime(timeHTML));
    }).on('finish.countdown', function(){
      loopDate = setCounterDate(loopTime,true);
      loopDate = new Date(loopDate);
      $('.timerCountdown').countdown(loopDate);
    });
    $timer.show();
  } else if($('.timerCountdown').attr('data').trim() != '') {
    var endDate = $('.timerCountdown').attr('data');
    $timer.show();
    $('.timerCountdown').countdown(endDate,function(event) {
      $(this).html(event.strftime(timeHTML));
    }).on('finish.countdown', function(){
      $timer.hide();
    });
  }
}

$(document).ready(function(){
  if($('.jsAccordion').length) {
    var parentId = $('.jsAccordion .card:eq(0) .collapse').attr('data-parent');
    if(typeof parentId != 'undefined') {
      parentId = parentId.replace('#','').trim();
      $('.jsAccordion').attr('id',parentId);
    }
  }
  
  if($('.jsOpenAcord').length) {
    var $card = $('.jsOpenAcord .card:first-child');
    $card.find('.card-sub-header a').attr('aria-expanded','true');
    $card.find('.card-body').parent().addClass('show');
  }
  
  //CD
  if($('.freeShipMsg').length) {
    var date,nowDate,oneDay = 24 * 60 * 60 * 1000,daysCount,weeksCount,shipMsg;
    $('.freeShipMsg').each(function(){
      var $form = $(this).parents('form.formProduct');
      if($form.find('.endShipDate').length) {
        date = $form.find('.endShipDate').val();
        date = new Date(date);
        nowDate = new Date();
        daysCount = date - nowDate;
        if(daysCount > 0) {
          daysCount = Math.round(daysCount/oneDay);
          weeksCount = Math.round(daysCount/7);
          shipMsg = $form.find('.freeShipMsg p').html().replace(/week(s)*/gi,'');
          $form.find('.freeShipMsg p').html(shipMsg);
          if(weeksCount > 0) {
            if(weeksCount > 1) {
              $form.find('.freeShipMsg .wekCount').text(weeksCount+' weeks');
            } else {
              $form.find('.freeShipMsg .wekCount').text(weeksCount+' week');
            }
            $form.find('.freeShipMsg').show();
          } else if(weeksCount == 0) {
            $form.find('.freeShipMsg .wekCount').text('1 week');
            $form.find('.freeShipMsg').show();
          }
        }
      } else {
        $form.find('.freeShipMsg').show();
      }
    });
  }
});

//CD [selected 2nd variant on page load for gift product only]
$(function(){
  if($('.productSwatches').length) {
    if($('.productSwatches').hasClass('giftSwatch')) {
      var $opt = $('.giftSwatch .clickyboxes li a[data-value="$100"]');
      if($opt.length) {
        $opt.trigger('click');
      }
    }
  }
  
  if($('.jsAccord.active').length) {
    $('.jsAccord.active').each(function(){
      $(this).find('.accord-body[data-level="'+$(this).attr('data-level')+'"]').slideDown();
    });
  }
  
  $('.jsAccordHeader').on('click',function(){
    var $accord = $(this).parent('.jsAccord');
    var level = $accord.attr('data-level');
    if($accord.hasClass('no-expand')) { 
      if(typeof $accord.attr('data-action') != 'undefined') {
        if($accord.attr('data-action').trim() != '') {
          location.href = $accord.attr('data-action');
        }
      }
      return; 
    }
    $accord.toggleClass('active');
    $accord.find('.jsAccordBody[data-level="'+level+'"]').slideToggle();
    $accord.siblings('.jsAccord').find('.jsAccordBody').slideUp();
    $accord.siblings('.jsAccord').removeClass('active');
  });
});

function bundleAdd(id_arr) {
  if(id_arr.length) {
    var id = id_arr.shift();
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: id,
        quantity: 1
      },
      complete: function(){
        bundleAdd(id_arr);
      }
    });
  } else {
    location.href = '/checkout';
  }
}

$(document).on('click','.bundleReorder',function(){
  if($(this).hasClass('btn-disabled')) return;
  var id_arr = $(this).attr('data').split('|');
  $(this).addClass('btn-disabled');
  bundleAdd(id_arr);
});

/* CD chat widget changes */
/*var maxRepetitions = 60
var repetitionCount = 0
var isWindowStyleAppended = false
var gorgiasChatInterval = window.setInterval(function() {
  var container = document.querySelector('#gorgias-chat-container');
  var chatButtonHead = container?.querySelector('#chat-button')?.contentWindow.document.querySelector('head');
  var chatWindowHead = container?.querySelector('#chat-window')?.contentWindow.document.querySelector('head');
  var chatCampaignsHead = container?.querySelector('#chat-campaigns')?.contentWindow.document.querySelector('head');

  if (chatButtonHead?.children.length && chatWindowHead?.children.length && !isWindowStyleAppended) {
  var buttonStyle = document.createElement('style');
  buttonStyle.textContent = '.messenger-button-iframe-clht14 svg {opacity: 0;visibility: hidden;}.messenger-button-iframe-clht14 {box-shadow: none;position: relative;}.messenger-button-iframe-clht14:before {content: "";position: absolute;height: 32px;width: 32px;background: url(https://cdn.shopify.com/s/files/1/0033/7824/9774/files/chat-icon-gm.png) no-repeat center; background-size: contain; left: 0; right: 0; top: 0; bottom: 0;}'; // the custom CSS for the chat button
  chatButtonHead.appendChild(buttonStyle);

  var windowStyles = document.createElement('style');
  windowStyles.textContent = '.logo-wrapper {display: none}'; // the custom CSS for the chat window
  chatWindowHead.appendChild(windowStyles);
  isWindowStyleAppended = true;
  }

  if (chatCampaignsHead?.children.length) {
  window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.

  var campaignStyles = document.createElement('style');
  campaignStyles.textContent = '.whatyouwanttochange {property: value}'; // the custom CSS for the chat campaigns
  chatCampaignsHead.appendChild(campaignStyles);
  }

  if (++repetitionCount == maxRepetitions) {
  window.clearInterval(gorgiasChatInterval);
  }
  }, 100);*/

  //CD
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  $(document).on('click','.stamped-rewards-widget-btn-sign-in,.stamped-rewards-widget-btn-sign-up',function(e){
    if(getCookie('grgmn_rewards_action') == '') {
      setCookie('grgmn_rewards_action',1,365);
    }
  });

  $(document).ready(function(){
    var return_markup = '<input type="hidden" name="return_to" value="/pages/rewards">';
    if(getCookie('grgmn_register_action') != '') {
      if($('.template-index').length) {
        setCookie('grgmn_register_action','',0);
        location.href = '/account';
      } else {
        $('body').removeClass('invisible');
      }
      if($('.account-page').length || $('.template-register').length) setCookie('grgmn_register_action','',0);
    } else {
      $('body').removeClass('invisible');
    }
    if(getCookie('grgmn_rewards_action') != '') {
      if($('.account-page').length || $('.template-index').length) {
        location.href = '/pages/rewards';
      }
      /*if($('.login-page form#customer_login').length) {
        $('.login-page form#customer_login').append(return_markup);
        if($('.login-page form#customer_login input[name="return_url"]').length) $('.login-page form#customer_login input[name="return_url"]').remove();
      }
      if($('.account-form form#create_customer').length) {
        $('.account-form form#create_customer').append(return_markup);
      }*/
    }
    /*if($('.shopify-challenge__button').length) {
      if(getCookie('grgmn_rewards_action') == '2') {
        $('.shopify-challenge__button').parents('form').append(return_markup);
      }
    }*/
    if($('#rewards').length) {
      if(getCookie('grgmn_rewards_action') != '') {
        setCookie('grgmn_rewards_action','',0);
      }
    }
  });

  $(document).on('submit','.account-form form#create_customer',function(){
    if(getCookie('grgmn_register_action') == '') {
      setCookie('grgmn_register_action',1,365);
    }
  });

  /*$(document).on('submit','.account-form form#create_customer,.login-page form#customer_login',function(){
    if(getCookie('grgmn_rewards_action') != '') {
      setCookie('grgmn_rewards_action',2,365);
    }
  });*/

$('.proQty').on('change',function(){
  var times = parseInt($(this).attr('data-times'));
  var qty = parseInt($(this).val())*times;
  $('.product_detail .times-pack').text(qty);
});


function adjust_upsell() {
  if($('.template-cart').length) {
    var upsell = window.upsell,upsell_price;
    var upsell_id = upsell.product_id,upsell_exist = false; 

    if(upsell.enable == 'true' && upsell_id != '') {
      $.getJSON('/cart.js',function(cart){
        upsell_price = parseInt(upsell.threshold);
        upsell_price = isNaN(upsell_price)?0:upsell_price;
        upsell_price = upsell_price*100;

        cart.items.forEach(function(item,index){
          if(item.variant_id == upsell_id) {
            upsell_exist = true;
            return false;
          }
        });

        var post_data = {
          id: upsell_id,
          quantity: 1
        };
        if(typeof upsell.original_price != "undefined") {
          post_data["properties"] = {
            "Original price": upsell.original_price
          }
        }

        if(cart.total_price >= upsell_price) {
          if(!upsell_exist) {
            $.ajax({
              url: '/cart/add.js',
              type: 'post',
              dataType: 'json',
              data: post_data,
              success: function(){
                location.reload();
              }
            });
          }
        } else {
          if(upsell_exist) {
            $.ajax({
              url: '/cart/change.js',
              type: 'post',
              dataType: 'json',
              data: {
                id: upsell_id,
                quantity: 0
              },
              success: function(){
                location.reload();
              }
            });
          }
        }
      });
    }
  }
}

$(function(){
  adjust_upsell();
  
  $('.searchBtn').on('click',function(e){
    var $searchField = $(this).parents('.search-form').find('input[type="search"]');
    if($searchField.val().trim() == '') {
      e.preventDefault();
      $searchField.focus();
    }
  });
});

//bundle page
function remove_bundle(active_drawer = true) {
  var updates = {};
  $('.bundle_item').each(function(){
    updates[$(this).attr('data')] = 0;
  });
  $('.remove_bundle').addClass('disabled');
  if(Object.keys(updates).length) {
    $.ajax({
      url: '/cart/update.js',
      type: 'post',
      dataType: 'json',
      data: {
        updates: updates
      },
      complete: function(){
        $('.remove_bundle').removeClass('disabled');
        $('.btn_buy').find('.btn-text').text('add bundle to cart');
        $('.btn_buy').removeClass('btn_buy_update');
        refreshSideCart(active_drawer);
      }
    });
  }
}

function removeHTML(str){ 
  var tmp = document.createElement("DIV");
  tmp.innerHTML = str;
  return tmp.textContent || tmp.innerText || "";
}

function calculate_price() {
  var total_price = 0, original_total = 0, total_items = 0, discount = 0,sep_discnt,price,dis_price,final_discount,discount_text,more_pro_text,next_discount;
  $('.buy_item .item_qty').each(function(){
    total_items = total_items + parseInt($(this).text());
  });
  if(total_items >= 5) {
    discount_text = 35;
    discount = 20.15;
    sep_discnt = 22;
  } else if(total_items >= 4) { 
    discount_text = 25;
    discount = 9;
    sep_discnt = 11.04;
    more_pro_text = 'one';
    next_discount = '35%';
  } else if(total_items >= 3) { 
    discount_text = 20;
    discount = 3.2;
    sep_discnt = 5.48;
    more_pro_text = 'one';
    next_discount = '25%';
  }else if(total_items >= 2){
    more_pro_text = 'one';
    next_discount = '20%';
  }else if(total_items >= 1){
    more_pro_text = 'two';
    next_discount = '20%';
  }
  
  $('.buy_item').each(function(){
    price = parseInt($(this).find('.r_price').attr('data'));
    if(discount > 0) {
      final_discount = discount;
      if($('.sep_dis_pro').length) {
        if($('.sep_dis_pro').val() == $(this).attr('handle')) final_discount = sep_discnt;
      }
      dis_price = price - ((price/100)*final_discount);
      // $(this).find('.r_price').html(slate.Currency.formatMoney(dis_price, theme.moneyFormat).replace(' AUD',''));
      $(this).find('.r_price').text(removeHTML(slate.Currency.formatMoney(dis_price, theme.moneyFormat)).replace(' EUR',''));
      total_price = total_price + dis_price;
    } else {
      // $(this).find('.r_price').html(slate.Currency.formatMoney(price, theme.moneyFormat).replace(' AUD',''));
      $(this).find('.r_price').text(removeHTML(slate.Currency.formatMoney(price, theme.moneyFormat)).replace(' EUR',''));
      total_price = total_price + price;
    }
    if(!$(this).find('.c_price').hasClass('hide')) price = parseInt($(this).find('.c_price').attr('data'));
    original_total = original_total + price;
  });
  
  if(discount > 0) {
    // $('.buy_box .dis_amnt').html(slate.Currency.formatMoney(original_total - total_price, theme.moneyFormat).replace(' AUD',''));
    $('.buy_box .dis_amnt').text(removeHTML(slate.Currency.formatMoney(original_total - total_price, theme.moneyFormat)).replace(' EUR',''));
    $('.buy_box .dis_percnt').text(discount_text);
    $('.buy_box .buy-text').removeClass('hidden');
  } else {
    $('.buy_box .buy-text').addClass('hidden');
  }

  // CD Arshit
  if(more_pro_text == 'one'){
    $('.buy_box .buy_more_text .product_text').text('product');
  }else{
    $('.buy_box .buy_more_text .product_text').text('products');
  }
  if(total_items >= 5){
    $('.buy_box .buy_more_text').addClass('hidden');
  }else{
    $('.buy_box .buy_more_text').removeClass('hidden');
    $('.buy_box .buy_more_text .more_pro_text').text(more_pro_text);
    $('.buy_box .buy_more_text .next_discount').text(next_discount);
  }
  
  // $('.buy_box .total_price').html(slate.Currency.formatMoney(total_price, theme.moneyFormat).replace(' AUD',''));
  $('.buy_box .total_price').text(removeHTML(slate.Currency.formatMoney(total_price, theme.moneyFormat)).replace(' EUR',''));
}

function set_bundle(){
  if(getCookie('grmn_bundle') != '') {
    var bundle = {},$buy_html = $($('.buyitem_html').html()),buy_json,$product,price,c_price;
    bundle = decodeURI(getCookie('grmn_bundle'));
    bundle = JSON.parse(bundle);
    for(var bundle_id in bundle) {
      $buy_html = $buy_html.clone();
      $product = $('.productBlock[data="'+bundle_id+'"]');
      buy_json = $product.find('.buy_json').html();
      buy_json = JSON.parse(buy_json);
      price = parseInt(buy_json.price);
      c_price = (buy_json.compare_price != '')?parseInt(buy_json.compare_price):0;
      
      $buy_html.attr('handle',buy_json.handle);
      $buy_html.find('.item_name').text(buy_json.title);
      $buy_html.find('.item_qty').text(bundle[bundle_id]);
      $buy_html.attr('data',$product.find('input[name="id"]').val());
      // $buy_html.find('.r_price').html(slate.Currency.formatMoney(price*parseInt(bundle[bundle_id]), theme.moneyFormat).replace(' AUD','')).attr('data',price*parseInt(bundle[bundle_id]));
      $buy_html.find('.r_price').text(removeHTML(slate.Currency.formatMoney(price*parseInt(bundle[bundle_id]), theme.moneyFormat)).replace(' EUR','')).attr('data',price*parseInt(bundle[bundle_id]));
      if(c_price > price) {
        $buy_html.find('.r_price').addClass('sale-price');
        // $buy_html.find('.c_price').html(slate.Currency.formatMoney(c_price*parseInt(bundle[bundle_id]), theme.moneyFormat).replace(' AUD','')).attr('data',c_price*parseInt(bundle[bundle_id]));
        $buy_html.find('.c_price').text(removeHTML(slate.Currency.formatMoney(c_price*parseInt(bundle[bundle_id]), theme.moneyFormat)).replace(' EUR','')).attr('data',c_price*parseInt(bundle[bundle_id]));
      } else {
        $buy_html.find('.c_price').addClass('hide');
      }
      $product.find('.inputQty').val(bundle[bundle_id]);
      $('.added_products').append($buy_html);

      // CD Arshit New Changes
      var qty_box = $product.find('.inputQty');
      replace_minus_icon(qty_box, bundle[bundle_id]);
      
    }
    if($('.added_products').is(':empty')) {
      $('.buy_box').removeClass('open-box');
    } else {
      $('.buy_box').addClass('open-box');
    }
    calculate_price();
  }
}

function manage_cookie() {
  var varaints = {};
  $('.buy_item').each(function(){
    varaints[$(this).attr('data')] = $(this).find('.item_qty').text();
  });
  setCookie('grmn_bundle',encodeURI(JSON.stringify(varaints)),365);
}

$(document).on('click','.close_buy',function(e){
  e.preventDefault();
  $('.buy_box').removeClass('open-box');
  $('.bundle_toggle').addClass('active');
});

$(document).on('click','.remove_btn',function(){
  var $buy_item = $(this).parents('.buy_item');
  var var_id = $buy_item.attr('data');
  $buy_item.remove();
  $('.productBlock[data="'+var_id+'"]').find('.inputQty').val(0);

  // CD Arshit New Changes
  var qty_box = $('.productBlock[data="'+var_id+'"]').find('.inputQty');
  replace_minus_icon(qty_box, 0);
  
  if($('.added_products').is(':empty')) {
    $('.buy_box').removeClass('open-box');
    if($('.btn_buy').hasClass('btn_buy_update')) remove_bundle(false);
  } 
  
  manage_cookie();
  calculate_price();
});

function bundle_add(products_arr) {
  if(products_arr.length) {
    var product = products_arr.shift();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      dataType: 'json',
      data: {
        id: product.id,
        quantity: product.quantity,
        properties: {
          '_bundle_pro': 'true'
        }
      },
      complete: function(){
        bundle_add(products_arr);
      }
    });
  } else {
    $('.btn_buy').find('.btn-text').text('update bundle');
    $('.btn_buy').addClass('btn_buy_update').removeClass('loading');
    
    refreshSideCart();
  }
}

function manage_bundles(var_id,qty) {
  var $product = $('.bundle-products .productBlock[data="'+var_id+'"]'),buy_json,price,c_price,t_price,t_c_price,call_action = true;
  if(qty > 0) {
    $('.buy_item[data="'+var_id+'"] .item_qty').text(qty);
    if($product.length) {
      buy_json = JSON.parse($product.find('.buy_json').html());
      price = parseInt(buy_json.price);
      c_price = (buy_json.compare_price != '')?parseInt(buy_json.compare_price):0;
      t_price = price * parseInt(qty);
      // $('.buy_item[data="'+var_id+'"] .r_price').html(slate.Currency.formatMoney(t_price, theme.moneyFormat).replace(' AUD','')).attr('data',t_price);
      $('.buy_item[data="'+var_id+'"] .r_price').text(removeHTML(slate.Currency.formatMoney(t_price, theme.moneyFormat)).replace(' EUR','')).attr('data',t_price);
      if(c_price > price) {
        t_c_price = c_price * parseInt(qty);
        // $('.buy_item[data="'+var_id+'"] .c_price').html(slate.Currency.formatMoney(t_c_price, theme.moneyFormat).replace(' AUD','')).attr('data',t_c_price);
        $('.buy_item[data="'+var_id+'"] .c_price').text(removeHTML(slate.Currency.formatMoney(t_c_price, theme.moneyFormat)).replace(' EUR','')).attr('data',t_c_price);
      }
    }
  } else {
    $('.buy_item[data="'+var_id+'"]').remove();
    if($('.added_products').is(':empty')) {
      setCookie('grmn_bundle','',0);
      $('.buy_box').removeClass('open-box');
      $('.buy_box .buy-text').addClass('hidden');
      $('.bundle_toggle').removeClass('active');
      $('.btn_buy').find('.btn-text').text('add bundle to cart');
      $('.btn_buy').removeClass('btn_buy_update');
      call_action = false;
    }
  }
  $product.find('.inputQty').val(qty);
  if(call_action) {
    manage_cookie();
    calculate_price();
  }
}

$(document).on('click','.buy_action',function(){
  var $product = $(this).parents('.product-block');
  var $popup_qty;
  if($(this).hasClass('popup_action')) {
    $product = $('.product-block[data="'+$(this).parents('.product_wrap').attr('data')+'"]');
    $popup_qty = $(this).parents('.product_wrap').find('.qty .inputQty');
    $product.find('.inputQty').val($popup_qty.val());
  }
  
  if(typeof $product == 'undefined') return;
  
  var $qty = $product.find('.inputQty');
  var buy_json = $product.find('.buy_json').html();
  var $buy_html = $($('.buyitem_html').html()),price,c_price,t_price,t_c_price;
  var var_id = $product.find('input[name="id"]').val();
  buy_json = JSON.parse(buy_json);
  if($(this).hasClass('btnAddToCart')) {
    $qty.val(parseInt($qty.val())+1);

    // CD Arshit New Changes
    var qty_val = parseInt($qty.val());
    replace_minus_icon($qty, qty_val);
    
    if($(this).hasClass('popup_action')) {
      $popup_qty.val(parseInt($popup_qty.val())+1);
      close_bundle_popup();
    }
  }
  price = parseInt(buy_json.price);
  c_price = (buy_json.compare_price != '')?parseInt(buy_json.compare_price):0;
  
  if($('.buy_item[data="'+var_id+'"]').length) {
    $('.buy_item[data="'+var_id+'"]').find('.item_qty').text($qty.val());
    
    t_price = price * parseInt($qty.val());
    // $('.buy_item[data="'+var_id+'"] .r_price').html(slate.Currency.formatMoney(t_price, theme.moneyFormat).replace(' AUD','')).attr('data',t_price);
    $('.buy_item[data="'+var_id+'"] .r_price').text(removeHTML(slate.Currency.formatMoney(t_price, theme.moneyFormat)).replace(' EUR','')).attr('data',t_price);
    if(c_price > price) {
      t_c_price = c_price * parseInt($qty.val());
      // $('.buy_item[data="'+var_id+'"] .c_price').html(slate.Currency.formatMoney(t_c_price, theme.moneyFormat).replace(' AUD','')).attr('data',t_c_price);
      $('.buy_item[data="'+var_id+'"] .c_price').text(removeHTML(slate.Currency.formatMoney(t_c_price, theme.moneyFormat)).replace(' EUR','')).attr('data',t_c_price);
    }
  } else {
    $buy_html.attr('handle',buy_json.handle);
    $buy_html.find('.item_name').text(buy_json.title);
    $buy_html.find('.item_qty').text($qty.val());
    $buy_html.attr('data',$product.find('input[name="id"]').val());
    // $buy_html.find('.r_price').html(slate.Currency.formatMoney(price, theme.moneyFormat).replace(' AUD','')).attr('data',price);
    $buy_html.find('.r_price').text(removeHTML(slate.Currency.formatMoney(price, theme.moneyFormat)).replace(' EUR','')).attr('data',price);
    if(c_price > price) {
      $buy_html.find('.r_price').addClass('sale-price');
      // $buy_html.find('.c_price').html(slate.Currency.formatMoney(c_price, theme.moneyFormat).replace(' AUD','')).attr('data',c_price);;
      $buy_html.find('.c_price').text(removeHTML(slate.Currency.formatMoney(c_price, theme.moneyFormat)).replace(' EUR','')).attr('data',c_price);;
    } else {
      $buy_html.find('.c_price').addClass('hide');
    }
    $('.added_products').append($buy_html);
  }
  
  if(parseInt($qty.val()) == 0) $('.buy_item[data="'+var_id+'"]').remove();
  
  if($('.added_products').is(':empty')) {
    $('.buy_box').removeClass('open-box');
    $('.bundle_toggle').removeClass('active');
  } else {
    if(!$('.buy_box').hasClass('open-box')) {
      $('.bundle_toggle').removeClass('active');
      $('.buy_box').addClass('open-box');
    }
  }

  manage_cookie();
  calculate_price();
});

function close_bundle_popup() {
  $('.bundle_popup').removeClass('active').delay(301).queue(function(){
    $(this).addClass('loading').dequeue();
  }); 
}

$(function(){
  if($('.bundle-page').length) set_bundle();
  
  $(document).on('click','.btn_buy',function(){
    if($(this).hasClass('loading')) return;
    if(getCookie('grmn_bundle') == '') return;
    var products = JSON.parse(decodeURI(getCookie('grmn_bundle')));
    var products_arr = [],cart_items = [];
    var counter = 0;
    
    $('.btn_buy').addClass('loading');
    if($(this).hasClass('btn_buy_update')) {
      new_products = products;
      $.getJSON('/cart.js',function(cart){
        $.each(cart.items,function(index,item){
          if(typeof item.properties['_bundle_pro'] != 'undefined') {
            if(typeof products[item.variant_id] == 'undefined') {
              products[item.variant_id] = 0;
            }
          }
        });
        
        cart_items = cart.items.map(a => a.variant_id);
        
        $('.buy_item').each(function(){
          if(cart_items.indexOf(parseInt($(this).attr('data'))) == -1) {
            products_arr[counter] = {};
            products_arr[counter]['id'] = $(this).attr('data');
            products_arr[counter]['quantity'] = $(this).find('.item_qty').text();
            delete products[$(this).attr('data')];
            counter++;
          }
        });
        
        $.ajax({
          url: '/cart/update.js',
          type: 'post',
          dataType: 'json',
          data: {
            updates: products
          },
          complete: function(){
            if(products_arr.length) {
              bundle_add(products_arr);
            } else {
              $('.btn_buy').removeClass('loading');
              refreshSideCart();
            }
          }
        });
      });
    } else {
      for(var index in products) {
        products_arr[counter] = {};
        products_arr[counter]['id'] = index;
        products_arr[counter]['quantity'] = products[index];
        counter++;
      }
      bundle_add(products_arr);
    }
  });
  
  $(document).on('click','.remove_bundle',function(){
    if($(this).is(':disabled')) return;
    remove_bundle();
    setCookie('grmn_bundle','',0);
    $('.buy_box').removeClass('open-box');
    $('.added_products').empty();
    $('.buy_box .buy-text').addClass('hidden');
    $('.bundle-products .product-block .inputQty').val(0);
    $('.bundle_toggle').removeClass('active');
    $('.btn_buy').find('.btn-text').text('add bundle to cart');
    $('.btn_buy').removeClass('btn_buy_update');
  });
  
  $(document).on('click','.bundle_toggle',function(){
    $(this).removeClass('active');
    $('.buy_box').addClass('open-box');
  });
  
  $(document).on('click','.edit_bundle',function(e){
    e.preventDefault();
    if(location.pathname.indexOf('build-your-own-bundle') >= 0) {
      $('body').removeClass('sidecart-opened');
      if($('.added_products').is(':empty')) {
        $('.buy_box').removeClass('open-box');
      } else {
        $('.buy_box').addClass('open-box');
      }
      $('.bundle_toggle').removeClass('active');
    } else {
      location.href = '/pages/build-your-own-bundle';
    }
  });
  
  $(document).on('click','.buy_popup_close',function(){
    close_bundle_popup();
  });
  
  $(document).on('click','.open_popup',function(e){
    e.stopPropagation();
    var $this = $(this),$product = $this.parents('.productBlock'),$json,main_json,url;
    $('.bundle_popup').addClass('loading');
    $.ajax({
      url: '/products/'+$this.attr('data')+'?view=bundle',
      type: 'get',
      dataType: 'html',
      success: function(html){
        $('.bundle_popup').addClass('active').removeClass('loading');
        $('.popup_content').html(html);
        $('.popup_content .product-wrap .qty .inputQty').val($product.find('.productQty .inputQty').val());

        // CD Arshit New Changes
        var qty_box = $('.popup_content .product-wrap .qty .inputQty'),
            qty_val = $product.find('.productQty .inputQty').val();
        replace_minus_icon(qty_box, qty_val);
        
        $json = $('.popup_content').find('.mainProduct_json');
        if($json.length) {
          main_json = JSON.parse($json.html());
          url = 'https://stamped.io/api/widget?productId='+main_json.id+'&productName='+encodeURIComponent(main_json.title)+'&productSKU='+main_json.handle+'&page=1&apiKey=pubkey-10182kocwnMwJSr19gLMkB23VFtouw&storeUrl='+main_json.store_url.replace('https://','')+'&take=5'
          $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function(data){
              $('.popup_content').find('.reviews_count').text(data.count);
            }
          });
        }
      }
    });
  });
  
  $(document).on('click','.bundle-popup-wrap',function(e){
    if(!$(e.target).is('.bundle-popup') && $('.bundle-popup').has(e.target).length === 0) close_bundle_popup();
  });
  
  $(document).on('click','.cart_bundle_qty',function(){
    var var_id = $(this).attr('data-id');
    var qty = $(this).val();
    manage_bundles(var_id,qty);
  });
  
  $(document).on('click','.cart_bundle_action',function(){
    var var_id = $(this).attr('data-id');
    var qty = $(this).parents('.item-actions').find('.cart_bundle_qty').val();
    if($(this).hasClass('jsItemRemove')) qty = 0;
    manage_bundles(var_id,qty);
  });
});

//Load recently update content on browser back
if (performance.navigation.type === 2) {
  location.reload(true);
}

// cd code
$( window ).on("load", function() {
  // addEventListenerStamped(document, 'stamped:launcher:loaded', function(e) {});
  // set_use_now_btn();
  // set_medal_slider();
  // set_heart_icon();
  // hide_way_to_earn();
  
  // set use now btn
  var myInterval = setInterval(set_use_now_btn, 1000);
  function set_use_now_btn(){
    var use_points_btn = $('.stamped-customer-logged-in .stamped-rewards-widget-btn-redeem');
    if(use_points_btn.length){
      use_points_btn.removeAttr("onclick");
      use_points_btn.attr("href", "/pages/products");
      clearInterval(myInterval);
    }
  }
  
  // set medal slider  
  var set_medal_interval = setInterval(set_medal_slider, 1000);
  function set_medal_slider(){
    var old_content = $('.stamped-rewards-widget-text-holder');
    var medal_slider_html = $('.custom_medal_slider').html();
    var point_text = $('.stamped-rewards-widget-text-holder .stamped-rewards-widget-points.stamped-point-balance');
    var only_point = point_text.text().split(' ');
    if(old_content.length){
      point_text.text(only_point[0]);
      old_content.append(medal_slider_html);
      clearInterval(set_medal_interval);
    }
  }
  
  // set heart icon and customer name
  var set_heart_icon_interval = setInterval(set_heart_icon, 1000);
  function set_heart_icon(){
    var heart_old_content = $('.stamped-rewards-widget-title');
    if(heart_old_content.length){
      $(heart_old_content).html(heart_old_content.html()+ '!<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1090 1080" style="enable-background:new 0 0 1090 1080;" xml:space="preserve"> <style type="text/css"> .st0{fill:#F1D0C1;} .st1{fill:#231F20;} .st2{fill:none;stroke:#231F20;stroke-width:0.25;stroke-miterlimit:10;} </style> <path class="st0" d="M544.98,261.6c-13.32,15.22-29.94,37.85-20.08,42.87c-28.34-14.43-55.25-39.79-85.45-49.68  C308.88,212.01,213.59,318.8,208,440.92c-0.87,19.07,3.17,38.04,8.63,56.33c20.67,69.32,64.48,129.51,117.59,177.76  c55.34,50.28,118.81,76.83,182.19,113.05c25.33,14.48,51.64,27.25,78.68,38.22c8.11,3.29,16.4,6.48,23.37,11.78  c17.69,13.48,20.83,35.36,27.72,54.77c17.54-9.88,25.59-41.19,40.92-56.49c30.39-30.33,57.45-61.93,80.3-98.44  c28.57-45.64,50.82-94.94,69.38-145.41c16.26-44.19,38.55-96.8,37.26-144.56c-0.47-17.56-2.41-35.06-4.89-52.45  c-4.03-28.34-7.2-60.42-17.1-87.41c-8.41-22.92-25.56-44.11-39.21-64.25c-34.46-50.83-116.96-76.92-174.28-52.51  c-17.7,7.53-33.06,19.53-48.21,31.39c-10.65,8.34-21.3,16.68-31.95,25.02C556.53,249.17,551.11,254.61,544.98,261.6z"/> <path class="st1" d="M529.59,320.2c-2.65,0.9-5.29,1.81-8,2.71c-8.26,30.85-17.81,61.77-7.62,94.17c6,19.17,23.11,28.98,39.5,24.14  c15.75-4.65,24.53-20.78,16.52-40.15C558.57,373.25,543.27,347.05,529.59,320.2 M634.21,892.77c6.78-6.97,13.62-13.94,20.27-21.04  c91.46-96.82,165.04-204.41,197.77-335.57c20.72-82.94,20.27-165.56-13.55-245.79c-49.25-116.96-170.79-141.74-262.38-53.57  c-7.68,7.36-14.78,15.43-21.3,23.88c-28.53,37.05-27.63,36.66-3.16,75.9c12.72,20.46,23.56,42.41,32.34,64.74  c7.49,18.98,2.45,37.05-15.81,48.6c-15.43,9.75-40.47,7.1-52.48-9.55c-10.2-14.14-18.78-32.92-19.23-49.83  c-0.65-23.75,5.74-47.96,11.55-71.32c2.84-11.55,0.97-17.88-7.55-25.69c-81.39-74.16-207.96-51.12-261.99,49.96  c-48.54,90.69-28.72,176.08,29.56,254.44c61.58,82.81,146.97,136.25,237.2,182.4c30.47,15.56,62.29,28.34,93.46,42.54  c6,2.78,11.68,6.2,15.88,13.88c-3.74-0.13-7.87,0.9-11.1-0.39C483.37,788.28,370.36,728.38,280.7,632.08  c-48.02-51.64-79-111.4-82.42-183.5c-5.81-124.18,99.4-226.49,215.64-209.13c31.5,4.71,50.02,13.88,103.47,51.7  c5.87-9.36,11.49-18.91,17.75-28.08c26.53-38.86,60.99-68.22,106.31-82.17c88.88-27.43,171.43,13.88,209.51,104.5  c42.02,99.98,36.02,200.99,1.87,301.3c-40.08,117.86-110.69,216.61-197.38,304.59c-4.26,4.39-11.1,6.26-16.72,9.29  C637.25,898,635.7,895.36,634.21,892.77"/> <path class="st2" d="M529.59,320.2c-2.65,0.9-5.29,1.81-8,2.71c-8.26,30.85-17.81,61.77-7.62,94.17c6,19.17,23.11,28.98,39.5,24.14  c15.75-4.65,24.53-20.78,16.52-40.15C558.57,373.25,543.27,347.05,529.59,320.2z M634.21,892.77c6.78-6.97,13.62-13.94,20.27-21.04  c91.46-96.82,165.04-204.41,197.77-335.57c20.72-82.94,20.27-165.56-13.55-245.79c-49.25-116.96-170.79-141.74-262.38-53.57  c-7.68,7.36-14.78,15.43-21.3,23.88c-28.53,37.05-27.63,36.66-3.16,75.9c12.72,20.46,23.56,42.41,32.34,64.74  c7.49,18.98,2.45,37.05-15.81,48.6c-15.43,9.75-40.47,7.1-52.48-9.55c-10.2-14.14-18.78-32.92-19.23-49.83  c-0.65-23.75,5.74-47.96,11.55-71.32c2.84-11.55,0.97-17.88-7.55-25.69c-81.39-74.16-207.96-51.12-261.99,49.96  c-48.54,90.69-28.72,176.08,29.56,254.44c61.58,82.81,146.97,136.25,237.2,182.4c30.47,15.56,62.29,28.34,93.46,42.54  c6,2.78,11.68,6.2,15.88,13.88c-3.74-0.13-7.87,0.9-11.1-0.39C483.37,788.28,370.36,728.38,280.7,632.08  c-48.02-51.64-79-111.4-82.42-183.5c-5.81-124.18,99.4-226.49,215.64-209.13c31.5,4.71,50.02,13.88,103.47,51.7  c5.87-9.36,11.49-18.91,17.75-28.08c26.53-38.86,60.99-68.22,106.31-82.17c88.88-27.43,171.43,13.88,209.51,104.5  c42.02,99.98,36.02,200.99,1.87,301.3c-40.08,117.86-110.69,216.61-197.38,304.59c-4.26,4.39-11.1,6.26-16.72,9.29  C637.25,898,635.7,895.36,634.21,892.77z"/> </svg>');
      clearInterval(set_heart_icon_interval);
    }
  }

  // set way to earn
  var way_to_earn = setInterval(hide_way_to_earn, 1000);
  function hide_way_to_earn(){
    var reward_section = $('#stamped-rewards-widget[data-label-title="ways to earn points"] .stamped-rewards-widget-campaigns-earnings');
    var customer_account = $('body[customer_has_account]');
    if(reward_section.length){
      // var earn_item = $('#stamped-rewards-widget[data-label-title="ways to earn points"] .stamped-rewards-widget-item .stamped-rewards-widget-campaign-value')
      if(customer_account.length){
        // $.each(earn_item, function(key, value){
        //   if($(value).text().includes('up to 4 points for every $1 spent')){
        //     $(value).parents('.stamped-rewards-widget-item').css('display', "none");
        //   }
        // });
        var customer_vip_tier = $('body[stampedviptier]');
        if(customer_vip_tier.length){
          $('.stamped-rewards-widget-item[data-campaign-id="44827"]').addClass('hide');
        }else{
          $('[data-widget-type="rewards-earnings-v2"][data-logged-in="true"] [data-campaign-completed="false"][data-campaign-id="44827"] .stamped-rewards-widget-button[data-type="completed"]').css({'display': 'inline-block', 'visibility': 'visible', 'opacity': '1'});
        }
        $('.stamped-rewards-widget-item[data-campaign-id="44818"] , .stamped-rewards-widget-item[data-campaign-id="44826"], .stamped-rewards-widget-item[data-campaign-id="28218"], .stamped-rewards-widget-item[data-campaign-id="44827"]').css('order', '2');
        if(!$('.stamped-rewards-widget-item[data-campaign-id="28219"] .stamped-rewards-birthday-input-holder').length){
          $('.stamped-rewards-widget-item[data-campaign-id="28219"] .stamped-rewards-widget-campaign-value').addClass('hide');
          $('.stamped-rewards-widget-item[data-campaign-id="28219"] .stamped-rewards-widget-button').css('marginTop', '0');
        }
      }else{
        // $.each(earn_item, function( key, value){
        //   if($(value).text().includes('1 point for every $1 spent') || $(value).text().includes('2 points for every $1 spent') || $(value).text() == ('4 points for every $1 spent')){
        //     $(value).parents('.stamped-rewards-widget-item').css('display', "none");
        //   }
        // });
        $('.stamped-rewards-widget-item[data-campaign-id="44818"], .stamped-rewards-widget-item[data-campaign-id="44826"], .stamped-rewards-widget-item[data-campaign-id="28218"]').addClass('hide');
        $('.stamped-rewards-widget-item[data-campaign-id="44827"]').css('order', '2');
      }
      clearInterval(way_to_earn);
    }
  }

  // set chat icon
  var set_chat_icon_interval = setInterval(set_chat_icon, 100);
  function set_chat_icon(){
    var chat_old_content = $('iframe').contents().find('#gorgias-chat-messenger-button');
    if(chat_old_content.length){
      $(chat_old_content).find('.messenger-button-iframe-uscp54 .messenger-button-iframe-clht14').html('<img style="width: 100%; height: auto;" src="https://cdn.shopify.com/s/files/1/0566/8483/9089/files/gm_icon_0014_vector-smart-object_480.png?v=1671174324">');
      clearInterval(set_chat_icon_interval);
    }
  }
  
});

$(document).on('click', '.custom_benefits span.custom_link', function(){
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'TnLDnV']);
});

// product tag check
$(document).ready(function(){
  var new_date = new Date(),
      dd = new_date.getDate(),
      mm = new_date.getMonth() + 1,
      yyyy = new_date.getFullYear(),
      hour = new_date.getHours(),
      min = new_date.getMinutes(),
      sec = new_date.getSeconds();
  
  if(dd < 10) {dd = '0' + dd}
  if(mm < 10) {mm = '0' + mm}
  if(hour < 10) {hour = '0' + hour}
  if(min < 10) {min = '0' + min}
  if(sec < 10) {sec = '0' + sec}

  if($('body.main_body.custom_label_active').length){
    
    var currentDate= dd + "-" +( mm+1) + "-" + yyyy + "=" + hour + ":" + min + ":" + sec,
        main_body = $('body.main_body'),
        in_stock = main_body.attr('in_stock'),
        sale_pro = main_body.attr('sale_pro'),
        meta_label = main_body.attr('meta_label'),
        label_start_date = main_body.attr('label_start_date'),
        label_exp_date = main_body.attr('label_exp_date'),
        s_start_timeline = label_start_date.split('='),
        s_start_date = s_start_timeline[0].split('-'),
        s_start_time = s_start_timeline[1].split(':'),
        s_exp_timeline = label_exp_date.split('='),
        s_exp_date = s_exp_timeline[0].split('-'),
        s_exp_time = s_exp_timeline[1].split(':'),
        current_timestamp = new Date( yyyy, mm - 1, dd, hour, min, sec),
        start_timestamp = new Date(s_start_date[2], s_start_date[1] - 1, s_start_date[0], s_start_time[0], s_start_time[1], s_start_time[2]),
        end_timestamp = new Date(s_exp_date[2], s_exp_date[1] - 1, s_exp_date[0], s_exp_time[0], s_exp_time[1], s_exp_time[2]);
    
    if(in_stock == 'true' && sale_pro == 'true' && meta_label != ''){
      if(current_timestamp.getTime() > start_timestamp.getTime() && current_timestamp.getTime() < end_timestamp.getTime()){
        main_body.find('.custom_tag_label').addClass('hide');
        main_body.find('.custom_tag_label.'+ meta_label).removeClass('hide');
      }else{
        main_body.find('.custom_tag_label:not(.'+ meta_label +')').removeClass('hide');
      }
    }else{
      main_body.find('.custom_tag_label:not(.'+ meta_label +')').removeClass('hide');
    }
    
  }
});

// Mobile Menu Dropdown
$(document).on('click', '.js_menu_change', function(e){
  e.preventDefault();
  $(this).siblings('.js_menu_dropdown').slideToggle();
  $(this).toggleClass('menu_open');
});

// CD Nirav
$(document).on('click', '.js_klaviyo_btn_trigger', function(){
  if( $(this).parents('.productAdd').find('.klaviyo-bis-trigger').length){
    $(this).parents('.productAdd').find('.klaviyo-bis-trigger')[0].click();
  }
});

function new_cart_progress_bar(cart_total_price){
  var new_threshold1 = parseInt($('.new_threshhold .threshhold_details_inner').attr('free_shipping')),
      new_threshold2 = parseInt($('.new_threshhold .threshhold_details_inner').attr('free_threshold')),
      new_threshold3 = parseInt($('.new_threshhold .threshhold_details_inner').attr('third_threshold')),
      new_threshold3b = parseInt($('.new_threshhold .threshhold_details_inner').attr('third_b_threshold')),
      new_threshold1_title = '',
      new_threshold2_title = '',
      new_threshold3_title = '',
      threshhold_msg = '',
      progress_fill_width = 100,
      shipping_width = cart_total_price * 100 / new_threshold1,
      first_thresh_width = cart_total_price * 100 / new_threshold2,
      second_thresh_width = cart_total_price * 100 / new_threshold3,
      third_thresh_width = cart_total_price * 100 / new_threshold3b;

  $('.first_threshold .threshhold_title').each(function(index, thresh){
    if(index > 0){
      new_threshold1_title = new_threshold1_title + ' & ' + $(thresh).text();
    }else{
      new_threshold1_title = new_threshold1_title + $(thresh).text();
    }
  });
  $('.second_threshold .threshhold_title').each(function(index, thresh){
    if(index > 0){
      new_threshold2_title = new_threshold2_title + ' & ' + $(thresh).text();
    }else{
      new_threshold2_title = new_threshold2_title + $(thresh).text();
    }
  });
  $('.third_threshold .threshhold_title').each(function(index, thresh){
    if(index > 0){
      new_threshold3_title = new_threshold3_title + ' & ' + $(thresh).text();
    }else{
      new_threshold3_title = new_threshold3_title + $(thresh).text();
    }
  });

  $('.new_thresh_design .thresh_inner .threshhold_block').removeClass('active');
  if(shipping_width > 100){
    shipping_width = 100;
    $('.new_thresh_design .thresh_inner .threshhold_block.free_shipping_block').addClass('active');
  }
  if(first_thresh_width > 100){
    first_thresh_width = 100;
    $('.new_thresh_design .thresh_inner .threshhold_block.second_thresh_block').addClass('active');
  }
  if(second_thresh_width > 100){
    second_thresh_width = 100;
    $('.new_thresh_design .thresh_inner .threshhold_block.third_thresh_block').addClass('active');
  }
  if(third_thresh_width > 100){
    third_thresh_width = 100;
    $('.new_thresh_design .thresh_inner .threshhold_block.third_b_thresh_block').addClass('active');
  }

  $('.new_thresh_design .thresh_inner .threshhold_block.free_shipping_block .filled_thresh').css('width', shipping_width +'%');
  $('.new_thresh_design .thresh_inner .threshhold_block.second_thresh_block .filled_thresh').css('width', first_thresh_width +'%');
  $('.new_thresh_design .thresh_inner .threshhold_block.third_thresh_block .filled_thresh').css('width', second_thresh_width +'%');
  $('.new_thresh_design .thresh_inner .threshhold_block.third_b_thresh_block .filled_thresh').css('width', third_thresh_width +'%');

  var _third_threshhold = window.third_threshhold,
      _third_threshhold_id = _third_threshhold.product_id;

  if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
    progress_fill_width = 0;
  }
  
  if(new_threshold1 > new_threshold2){
    new_threshold1 = new_threshold2;
    new_threshold2 = parseInt($('.new_threshhold .threshhold_details_inner').attr('free_shipping'));
  }
  
  if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
    new_threshold1 = parseInt($('.new_threshhold .threshhold_details_inner .first_threshold').attr('thresh_price'));
    new_threshold2 = parseInt($('.new_threshhold .threshhold_details_inner .second_threshold').attr('thresh_price'));
    new_threshold3 = parseInt($('.new_threshhold .threshhold_details_inner .third_threshold').attr('thresh_price'));
  }
 
  if(new_threshold1 < cart_total_price){
    $('.first_threshold').addClass('active_threshhold');
    if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
      progress_fill_width = '33.33';
    }
  }else{
    $('.first_threshold').removeClass('active_threshhold');
  }
  if(new_threshold2 < cart_total_price){
    $('.second_threshold').addClass('active_threshhold');
    if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
      progress_fill_width = '66.67';
    }
  } else{
    $('.second_threshold').removeClass('active_threshhold');
  }
  if(new_threshold3 < cart_total_price){
    $('.third_threshold').addClass('active_threshhold');
    if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
      progress_fill_width = '100';
    }
  } else{
    $('.third_threshold').removeClass('active_threshhold');
  }

  if(_third_threshhold.enable == 'true' && _third_threshhold_id != '') {
    if(new_threshold3 > cart_total_price){
      threshhold_msg = "<b>" + slate.Currency.formatMoney((new_threshold3 - cart_total_price), theme.moneyFormat) + "</b> away from unlocking <b>" + new_threshold3_title + "</b>";
    }else{
      console.log(isNaN(new_threshold1), isNaN(new_threshold2))
      if($('.new_thresh_design .thresh_inner .threshhold_block').length == 1){
        threshhold_msg = "<b>" + new_threshold1_title + " UNLOCKED</b>";
      }else{
        threshhold_msg = '<b>mane jackpot unlocked! freebies are all yours! 🎉</b>';
      }
    }
    if(new_threshold2 > cart_total_price){
      threshhold_msg = "<b>" + slate.Currency.formatMoney((new_threshold2 - cart_total_price), theme.moneyFormat) + "</b> away from unlocking <b>" + new_threshold2_title + "</b>";
    }
  }else{
    if(new_threshold2 > cart_total_price){
      progress_fill_width = (cart_total_price * 100)/new_threshold2;
      if(isNaN(new_threshold1)){
        threshhold_msg = "<b>" + slate.Currency.formatMoney((new_threshold2 - cart_total_price), theme.moneyFormat) + "</b> away from unlocking <b>" + new_threshold1_title + "</b>";
      }else{
        threshhold_msg = "<b>" + slate.Currency.formatMoney((new_threshold2 - cart_total_price), theme.moneyFormat) + "</b> away from unlocking <b>" + new_threshold2_title + "</b>";
      }
    }else{
      if(isNaN(new_threshold1)){
        threshhold_msg = "<b>" + new_threshold1_title + " UNLOCKED</b>";
      }else{
        threshhold_msg = '<b>mane jackpot unlocked! freebies are all yours! 🎉</b>';
      }
      if(isNaN(new_threshold2)){
        threshhold_msg = "<b>" + new_threshold1_title + " UNLOCKED</b>";
      }
    }
  }
  
  if(new_threshold1 > cart_total_price){
    if(_third_threshhold.enable != 'true') {
      progress_fill_width = (cart_total_price * 100)/new_threshold1;
      if(!isNaN(new_threshold2)){
        progress_fill_width = (cart_total_price * 50)/new_threshold1;
        if(progress_fill_width > 50){
          progress_fill_width = progress_fill_width / 2;
        }
      }
    }
    threshhold_msg = "<b>" + slate.Currency.formatMoney((new_threshold1 - cart_total_price), theme.moneyFormat) + "</b> away from unlocking <b>" + new_threshold1_title + "</b>";
    if(progress_fill_width => 33.33){
      progress_fill_width = 6;
    }
  }

  $(':root').css('--progress-bar-icon',progress_fill_width+'%');
  $('.new_threshhold .filled_progress_bar').css('width' , progress_fill_width + '%');
  $('.threshhold_msg p').html(threshhold_msg);
}

$(document).on('click', '.sticky_atc_btn_inner .quantity.buttons_added input[type="button"]', function(){
  if($(this).hasClass('minus')){
    $('.formProduct.product-form .quantity.buttons_added input.minus').click();
  }else{
    $('.formProduct.product-form .quantity.buttons_added input.plus').click();
  }
});

$(document).on('click', '.sticky_atc_btn_inner .sticky_qty_inner .sticky_atc_btn', function(){
  $('.formProduct.product-form .product-addtocart-btn').click();
});

// CD Arshit New Changes
function replace_minus_icon(_this, qty){
  var svg_html = `<svg xmlns="http://www.w3.org/2000/svg" height="427pt" viewBox="-40 0 427 427.00131" width="427pt"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"></path><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path></svg>`;
  
  if(qty == 0){
    $(_this).parents('.productQty').find('.qtyBtn[data-action="minus"]').html('');
    if($(_this).parents('.bundle-popup').length){
      var pro_id = $(_this).parents('.bundle-popup').find('.product_wrap').attr('data');
      $('.productList .productBlock[data="'+ pro_id +'"] .productQty .qtyBtn[data-action="minus"]').html('');
    }
  }else if(qty == 1){
    $(_this).parents('.productQty').find('.qtyBtn[data-action="minus"]').html(svg_html);
    if($(_this).parents('.bundle-popup').length){
      var pro_id = $(_this).parents('.bundle-popup').find('.product_wrap').attr('data');
      $('.productList .productBlock[data="'+ pro_id +'"] .productQty .qtyBtn[data-action="minus"]').html(svg_html);
    }
  }else{
    $(_this).parents('.productQty').find('.qtyBtn[data-action="minus"]').html('-');
    if($(_this).parents('.bundle-popup').length){
      var pro_id = $(_this).parents('.bundle-popup').find('.product_wrap').attr('data');
      $('.productList .productBlock[data="'+ pro_id +'"] .productQty .qtyBtn[data-action="minus"]').html('-');
    }
  }
}

// if(screen.width < 641){
  if($(".product_with_tag .show_product_with_tag.apply_mobile_slider").length){
    $('.product_with_tag .show_product_with_tag.apply_mobile_slider').each(function(slider___slider) {
      $(this).slick({
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $(this).parent().find('.slider_arrow_left'),
        nextArrow: $(this).parent().find('.slider_arrow_right'),
        responsive: [
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }
// }

$(document).on('click', '#accordion .card .card-header h5', function(){
  var _this = $(this);
  setTimeout(function(){
    var scrollToTop = $(_this).parents('.shopify-section').offset().top,
        headerHeight = $('#shopify-section-header').height();
    window.scrollTo({ top: scrollToTop - headerHeight, behavior: 'smooth' });
  }, 500);
});

$(document).ready(function(){
  var open_drawer = false;
  refreshSideCart(open_drawer);

  if($('.new_thresh_design .thresh_inner .threshhold_block .thresh_text').length){
    var threshInterval = setInterval(changeThreshVal, 1000);
    function changeThreshVal(){
      var threshText = $('.new_thresh_design .thresh_inner .threshhold_block .thresh_text .money');
      if($(threshText).text().includes('.00')){
        $('.new_thresh_design .thresh_inner .threshhold_block .thresh_text .money').each(function(index, thresh_text){
          $(thresh_text).text($(thresh_text).text().replace('.00', ''));
        });
        clearInterval(threshInterval);
      }
    }
  }
  
});

// CD Arshit (Notify me)
$(document).on('click', '.js_klaviyo_button', function(){
  var kl_form_id = $(this).attr('kl_form_id');
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', kl_form_id]);
});

document.querySelectorAll('.js_pre_load_btn').forEach(function(elem){
  elem.addEventListener('click', function (){ window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', 'SGVag6']); }); 
});

document.addEventListener("qty:changed", function(e){
  var $target = e.detail;
  var qty = $target.val();
  set_compare_price($target, qty);
});


$('.formProduct input[name="quantity"]').on("change",function(e){
  set_compare_price($(this), $(this).val());
});

$(document).ready(function(){
  if(location.search.indexOf("open_drawer") >= 0) {
    $('body').addClass("sidecart-opened");
    const url = location.href;
    const urlObj = new URL(url);
    var search_str = "";
    const searchArr = urlObj.search.substr(1).split('&');
    searchArr.splice(searchArr.indexOf("open_drawer=1"),1);
    if(searchArr.length) search_str = '?'+searchArr.join("&");
    urlObj.search = search_str;
    const urlPath = urlObj.toString();
    window.history.pushState(null,null, urlPath);
  }
});